var oo = Object.defineProperty;
var ao = (e, t, s) => t in e ? oo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var et = (e, t, s) => (ao(e, typeof t != "symbol" ? t + "" : t, s), s);
import { SessionStatus as Nt, SessionCalendarType as io, MeetingType as bt, storageKeys as ve, Orientation as co, AppError as uo, ErrorCodes as lo, SessionAccessRuleStatus as vt, QueueStatus as F, ClockStatus as mo, MediaType as js } from "@waitroom/models";
import { isValidUrl as po, retry as Hs, getByKey as He, isFunction as zs, getViewerIdRoleName as fo, buildKey as Cs } from "@waitroom/utils";
import { useMutation as Vs, useQuery as at, useQueryClient as Xt } from "@tanstack/react-query";
import { updateConfig as Gs, authApiService as Te, userApiService as wt, integrationsApiService as Os, aiApiService as qs, sessionAccessApiService as So } from "@waitroom/common-api";
import { useDispatch as Ut, useSelector as ae } from "react-redux";
import Qs, { useMemo as je, useState as Rt, useCallback as Bs, useEffect as go } from "react";
import { produce as Pt } from "immer";
import Ws from "jwt-decode";
import { v4 as ho } from "uuid";
import { createSelector as E } from "reselect";
import { useUpdateEffect as yo } from "ahooks";
let K;
const Xd = (e) => {
  K = e;
}, em = (e, t) => {
  var s;
  return Number(((s = e.data) == null ? void 0 : s.code) || e.code) === t;
}, Ys = (e, t) => t.find((s) => s.name === e), Ks = (e, t) => t.find((s) => s.name === e), Js = (e, t) => t.find(({ provider: s }) => s.name === e), Zs = (e, t) => {
  for (let s = 0; s < t.length; s++) {
    const n = t[s], { provider: o } = Js(e.providerName, n.connectedProviders) || {};
    if (!o)
      continue;
    const a = Ks(
      e.integrationName,
      o.integrations
    );
    return a && Ys(e.actionName, a.actions) ? o : void 0;
  }
}, tm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  findAction: Ys,
  findIntegration: Ks,
  findLastUsedIntegrationProvider: Zs,
  findProvider: Js
}, Symbol.toStringTag, { value: "Module" })), vo = (e, t) => e && e.reduce(
  (s, n) => {
    const o = String(n[t]);
    return s.ids.push(o), s.entities[o] = n, s;
  },
  {
    ids: [],
    entities: {}
  }
), sm = (e) => {
  if (!(!e || !e.ids))
    return e.ids.reduce((t, s) => (t.push(e.entities[s]), t), []);
}, Eo = (e) => (e == null ? void 0 : e.sessionState) === Nt.IN_SESSION, nm = (e) => !!e.calendarID && e.calendarType === io.Google, Xs = (e, t) => {
  if (e.length === 1 || !t)
    return e;
  let s = e[0];
  const n = e.filter((o) => o.id !== t ? !0 : (s = o, !1));
  return [s, ...n];
}, To = (e, t) => t === void 0 ? e : t ? bt.PartyMode : bt.QueueMode, es = (e) => {
  var t;
  return To(e.meetingType, (t = e.sessionSettings) == null ? void 0 : t.isQueueDisabled);
}, rm = (e) => es(e) === bt.PartyMode, _o = {
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",
  twitter: "https://twitter.com/",
  linkedin: "https://www.linkedin.com/in/",
  tiktok: "https://www.tiktok.com/@",
  youtube: "https://www.youtube.com/c/",
  website: "//"
}, Io = (e, t) => bo(_o[e], t), bo = (e, t) => !e || !t || po(t) ? t || e : `${e}${t.trim().replace(/^@/, "")}`, om = (e) => !e || !e.length ? e : e.map((t) => ({
  ...t,
  url: Io(t.platform, t.url)
}));
var tt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ns;
function Ro() {
  if (Ns)
    return tt;
  Ns = 1;
  var e = Qs, t = Symbol.for("react.element"), s = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(u, c, d) {
    var m, R = {}, C = null, N = null;
    d !== void 0 && (C = "" + d), c.key !== void 0 && (C = "" + c.key), c.ref !== void 0 && (N = c.ref);
    for (m in c)
      n.call(c, m) && !a.hasOwnProperty(m) && (R[m] = c[m]);
    if (u && u.defaultProps)
      for (m in c = u.defaultProps, c)
        R[m] === void 0 && (R[m] = c[m]);
    return { $$typeof: t, type: u, key: C, ref: N, props: R, _owner: o.current };
  }
  return tt.Fragment = s, tt.jsx = i, tt.jsxs = i, tt;
}
var Et = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ws;
function Ao() {
  return ws || (ws = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Qs, t = Symbol.for("react.element"), s = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), j = Symbol.iterator, $e = "@@iterator";
    function Je(r) {
      if (r === null || typeof r != "object")
        return null;
      var l = j && r[j] || r[$e];
      return typeof l == "function" ? l : null;
    }
    var Se = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function H(r) {
      {
        for (var l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), T = 1; T < l; T++)
          f[T - 1] = arguments[T];
        Me("error", r, f);
      }
    }
    function Me(r, l, f) {
      {
        var T = Se.ReactDebugCurrentFrame, w = T.getStackAddendum();
        w !== "" && (l += "%s", f = f.concat([w]));
        var k = f.map(function(O) {
          return String(O);
        });
        k.unshift("Warning: " + l), Function.prototype.apply.call(console[r], console, k);
      }
    }
    var Ze = !1, Ne = !1, ce = !1, Z = !1, Fe = !1, Ie;
    Ie = Symbol.for("react.module.reference");
    function M(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === n || r === a || Fe || r === o || r === d || r === m || Z || r === N || Ze || Ne || ce || typeof r == "object" && r !== null && (r.$$typeof === C || r.$$typeof === R || r.$$typeof === i || r.$$typeof === u || r.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Ie || r.getModuleId !== void 0));
    }
    function U(r, l, f) {
      var T = r.displayName;
      if (T)
        return T;
      var w = l.displayName || l.name || "";
      return w !== "" ? f + "(" + w + ")" : f;
    }
    function Le(r) {
      return r.displayName || "Context";
    }
    function ue(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && H("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case n:
          return "Fragment";
        case s:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            var l = r;
            return Le(l) + ".Consumer";
          case i:
            var f = r;
            return Le(f._context) + ".Provider";
          case c:
            return U(r, r.render, "ForwardRef");
          case R:
            var T = r.displayName || null;
            return T !== null ? T : ue(r.type) || "Memo";
          case C: {
            var w = r, k = w._payload, O = w._init;
            try {
              return ue(O(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v = Object.assign, S = 0, p, y, h, _, I, D, $;
    function L() {
    }
    L.__reactDisabledLog = !0;
    function B() {
      {
        if (S === 0) {
          p = console.log, y = console.info, h = console.warn, _ = console.error, I = console.group, D = console.groupCollapsed, $ = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: L,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        S++;
      }
    }
    function te() {
      {
        if (S--, S === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: v({}, r, {
              value: p
            }),
            info: v({}, r, {
              value: y
            }),
            warn: v({}, r, {
              value: h
            }),
            error: v({}, r, {
              value: _
            }),
            group: v({}, r, {
              value: I
            }),
            groupCollapsed: v({}, r, {
              value: D
            }),
            groupEnd: v({}, r, {
              value: $
            })
          });
        }
        S < 0 && H("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ge = Se.ReactCurrentDispatcher, pe;
    function he(r, l, f) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (w) {
            var T = w.stack.trim().match(/\n( *(at )?)/);
            pe = T && T[1] || "";
          }
        return `
` + pe + r;
      }
    }
    var fe = !1, q;
    {
      var ye = typeof WeakMap == "function" ? WeakMap : Map;
      q = new ye();
    }
    function we(r, l) {
      if (!r || fe)
        return "";
      {
        var f = q.get(r);
        if (f !== void 0)
          return f;
      }
      var T;
      fe = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = ge.current, ge.current = null, B();
      try {
        if (l) {
          var O = function() {
            throw Error();
          };
          if (Object.defineProperty(O.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(O, []);
            } catch (be) {
              T = be;
            }
            Reflect.construct(r, [], O);
          } else {
            try {
              O.call();
            } catch (be) {
              T = be;
            }
            r.call(O.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (be) {
            T = be;
          }
          r();
        }
      } catch (be) {
        if (be && T && typeof be.stack == "string") {
          for (var A = be.stack.split(`
`), X = T.stack.split(`
`), x = A.length - 1, z = X.length - 1; x >= 1 && z >= 0 && A[x] !== X[z]; )
            z--;
          for (; x >= 1 && z >= 0; x--, z--)
            if (A[x] !== X[z]) {
              if (x !== 1 || z !== 1)
                do
                  if (x--, z--, z < 0 || A[x] !== X[z]) {
                    var le = `
` + A[x].replace(" at new ", " at ");
                    return r.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", r.displayName)), typeof r == "function" && q.set(r, le), le;
                  }
                while (x >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        fe = !1, ge.current = k, te(), Error.prepareStackTrace = w;
      }
      var Ge = r ? r.displayName || r.name : "", As = Ge ? he(Ge) : "";
      return typeof r == "function" && q.set(r, As), As;
    }
    function ze(r, l, f) {
      return we(r, !1);
    }
    function Lr(r) {
      var l = r.prototype;
      return !!(l && l.isReactComponent);
    }
    function gt(r, l, f) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return we(r, Lr(r));
      if (typeof r == "string")
        return he(r);
      switch (r) {
        case d:
          return he("Suspense");
        case m:
          return he("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            return ze(r.render);
          case R:
            return gt(r.type, l, f);
          case C: {
            var T = r, w = T._payload, k = T._init;
            try {
              return gt(k(w), l, f);
            } catch {
            }
          }
        }
      return "";
    }
    var ht = Object.prototype.hasOwnProperty, fs = {}, Ss = Se.ReactDebugCurrentFrame;
    function yt(r) {
      if (r) {
        var l = r._owner, f = gt(r.type, r._source, l ? l.type : null);
        Ss.setExtraStackFrame(f);
      } else
        Ss.setExtraStackFrame(null);
    }
    function xr(r, l, f, T, w) {
      {
        var k = Function.call.bind(ht);
        for (var O in r)
          if (k(r, O)) {
            var A = void 0;
            try {
              if (typeof r[O] != "function") {
                var X = Error((T || "React class") + ": " + f + " type `" + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[O] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              A = r[O](l, O, T, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              A = x;
            }
            A && !(A instanceof Error) && (yt(w), H("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", T || "React class", f, O, typeof A), yt(null)), A instanceof Error && !(A.message in fs) && (fs[A.message] = !0, yt(w), H("Failed %s type: %s", f, A.message), yt(null));
          }
      }
    }
    var jr = Array.isArray;
    function jt(r) {
      return jr(r);
    }
    function Hr(r) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, f = l && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return f;
      }
    }
    function zr(r) {
      try {
        return gs(r), !1;
      } catch {
        return !0;
      }
    }
    function gs(r) {
      return "" + r;
    }
    function hs(r) {
      if (zr(r))
        return H("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Hr(r)), gs(r);
    }
    var Xe = Se.ReactCurrentOwner, Vr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ys, vs, Ht;
    Ht = {};
    function Gr(r) {
      if (ht.call(r, "ref")) {
        var l = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function qr(r) {
      if (ht.call(r, "key")) {
        var l = Object.getOwnPropertyDescriptor(r, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function Qr(r, l) {
      if (typeof r.ref == "string" && Xe.current && l && Xe.current.stateNode !== l) {
        var f = ue(Xe.current.type);
        Ht[f] || (H('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ue(Xe.current.type), r.ref), Ht[f] = !0);
      }
    }
    function Br(r, l) {
      {
        var f = function() {
          ys || (ys = !0, H("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Wr(r, l) {
      {
        var f = function() {
          vs || (vs = !0, H("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        f.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var Yr = function(r, l, f, T, w, k, O) {
      var A = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: l,
        ref: f,
        props: O,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return A._store = {}, Object.defineProperty(A._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(A, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.defineProperty(A, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(A.props), Object.freeze(A)), A;
    };
    function Kr(r, l, f, T, w) {
      {
        var k, O = {}, A = null, X = null;
        f !== void 0 && (hs(f), A = "" + f), qr(l) && (hs(l.key), A = "" + l.key), Gr(l) && (X = l.ref, Qr(l, w));
        for (k in l)
          ht.call(l, k) && !Vr.hasOwnProperty(k) && (O[k] = l[k]);
        if (r && r.defaultProps) {
          var x = r.defaultProps;
          for (k in x)
            O[k] === void 0 && (O[k] = x[k]);
        }
        if (A || X) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          A && Br(O, z), X && Wr(O, z);
        }
        return Yr(r, A, X, w, T, Xe.current, O);
      }
    }
    var zt = Se.ReactCurrentOwner, Es = Se.ReactDebugCurrentFrame;
    function Ve(r) {
      if (r) {
        var l = r._owner, f = gt(r.type, r._source, l ? l.type : null);
        Es.setExtraStackFrame(f);
      } else
        Es.setExtraStackFrame(null);
    }
    var Vt;
    Vt = !1;
    function Gt(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function Ts() {
      {
        if (zt.current) {
          var r = ue(zt.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Jr(r) {
      {
        if (r !== void 0) {
          var l = r.fileName.replace(/^.*[\\\/]/, ""), f = r.lineNumber;
          return `

Check your code at ` + l + ":" + f + ".";
        }
        return "";
      }
    }
    var _s = {};
    function Zr(r) {
      {
        var l = Ts();
        if (!l) {
          var f = typeof r == "string" ? r : r.displayName || r.name;
          f && (l = `

Check the top-level render call using <` + f + ">.");
        }
        return l;
      }
    }
    function Is(r, l) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var f = Zr(l);
        if (_s[f])
          return;
        _s[f] = !0;
        var T = "";
        r && r._owner && r._owner !== zt.current && (T = " It was passed a child from " + ue(r._owner.type) + "."), Ve(r), H('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, T), Ve(null);
      }
    }
    function bs(r, l) {
      {
        if (typeof r != "object")
          return;
        if (jt(r))
          for (var f = 0; f < r.length; f++) {
            var T = r[f];
            Gt(T) && Is(T, l);
          }
        else if (Gt(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var w = Je(r);
          if (typeof w == "function" && w !== r.entries)
            for (var k = w.call(r), O; !(O = k.next()).done; )
              Gt(O.value) && Is(O.value, l);
        }
      }
    }
    function Xr(r) {
      {
        var l = r.type;
        if (l == null || typeof l == "string")
          return;
        var f;
        if (typeof l == "function")
          f = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === R))
          f = l.propTypes;
        else
          return;
        if (f) {
          var T = ue(l);
          xr(f, r.props, "prop", T, r);
        } else if (l.PropTypes !== void 0 && !Vt) {
          Vt = !0;
          var w = ue(l);
          H("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && H("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function eo(r) {
      {
        for (var l = Object.keys(r.props), f = 0; f < l.length; f++) {
          var T = l[f];
          if (T !== "children" && T !== "key") {
            Ve(r), H("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", T), Ve(null);
            break;
          }
        }
        r.ref !== null && (Ve(r), H("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    function Rs(r, l, f, T, w, k) {
      {
        var O = M(r);
        if (!O) {
          var A = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (A += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Jr(w);
          X ? A += X : A += Ts();
          var x;
          r === null ? x = "null" : jt(r) ? x = "array" : r !== void 0 && r.$$typeof === t ? (x = "<" + (ue(r.type) || "Unknown") + " />", A = " Did you accidentally export a JSX literal instead of a component?") : x = typeof r, H("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, A);
        }
        var z = Kr(r, l, f, w, k);
        if (z == null)
          return z;
        if (O) {
          var le = l.children;
          if (le !== void 0)
            if (T)
              if (jt(le)) {
                for (var Ge = 0; Ge < le.length; Ge++)
                  bs(le[Ge], r);
                Object.freeze && Object.freeze(le);
              } else
                H("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              bs(le, r);
        }
        return r === n ? eo(z) : Xr(z), z;
      }
    }
    function to(r, l, f) {
      return Rs(r, l, f, !0);
    }
    function so(r, l, f) {
      return Rs(r, l, f, !1);
    }
    var no = so, ro = to;
    Et.Fragment = n, Et.jsx = no, Et.jsxs = ro;
  }()), Et;
}
process.env.NODE_ENV === "production" ? Ro() : Ao();
function g(e) {
  return typeof e == "function" ? e : (...t) => {
    const s = { type: e, payload: t[0] };
    return t.length > 1 && (s.meta = t[1]), s;
  };
}
const Co = "[ACTION]", en = "[ACTION][REQUEST]", tn = "[ACTION][SUCCESS]", sn = "[ACTION][FAILURE]", Oo = "ACTION", nn = "ACTION_REQUEST", rn = "ACTION_SUCCESS", on = "ACTION_FAILURE", an = "ACTION_REMOVE", cn = "ACTION_CLEAR", un = (e) => `${en}/${e}`, ln = (e) => `${tn}/${e}`, dn = (e) => `${sn}/${e}`, mn = "auth/LOGOUT", pn = "auth/SETUP_AUTH", am = "auth/ADD_USER_ROLE", im = "auth/REMOVE_USER_ROLE", No = "auth/UPDATE_USER_ROLES", fn = "auth/SET_CURRENT_USER", Sn = "auth/UPDATE_CURRENT_USER", cm = "auth/SET_CURRENT_USER_SUBSCRIPTION_PLAN", gn = "auth/SET_AUTH_STATE", hn = "auth/UPDATE_AUTH_STATE", yn = "auth/SET_SUBSCRIPTION_PLAN", vn = "auth/REFRESH_SUBSCRIPTION_PLAN", rt = "auth/REQUEST_OTP", um = "auth/REQUEST_OTP_SUCCESS", lm = "auth/REQUEST_OTP_FAILURE", Ee = "auth/VERIFY_OTP", dm = un(Ee), mm = ln(Ee), pm = dn(Ee), ot = "auth/VERIFY_AUTH_PROVIDER", fm = "auth/VERIFY_AUTH_PROVIDER_SUCCESS", Sm = "auth/VERIFY_AUTH_PROVIDER_FAILURE", En = "auth/AUTHENTICATED", wo = "auth/UN_AUTHENTICATED", Uo = "auth/REQUEST_USER_SESSION_INFO", Tn = "auth/REQUEST_USER_SESSION_INFO_RESPONSE", Po = "auth/REQUEST_USER_SESSION_INFO_RESPONSE_ERROR", xe = "auth/GET_CURRENT_USER", gm = un(xe), hm = ln(xe), ym = dn(xe), _n = g(pn), Qe = g(gn), Ae = g(hn), vm = g(xe), Em = g(fn), Tm = g(Sn), Do = g(mn), ko = g(rt), $o = g(ot), Mo = g(Ee), Dt = g(En), kt = g(wo), _m = g(Uo), Im = g(Tn), bm = g(Po), Rm = g(No), At = g(yn), Am = g(vn);
var Fo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function In(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Lo = function(t) {
  return xo(t) && !jo(t);
};
function xo(e) {
  return !!e && typeof e == "object";
}
function jo(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || Vo(e);
}
var Ho = typeof Symbol == "function" && Symbol.for, zo = Ho ? Symbol.for("react.element") : 60103;
function Vo(e) {
  return e.$$typeof === zo;
}
function Go(e) {
  return Array.isArray(e) ? [] : {};
}
function it(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Be(Go(e), e, t) : e;
}
function qo(e, t, s) {
  return e.concat(t).map(function(n) {
    return it(n, s);
  });
}
function Qo(e, t) {
  if (!t.customMerge)
    return Be;
  var s = t.customMerge(e);
  return typeof s == "function" ? s : Be;
}
function Bo(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function Us(e) {
  return Object.keys(e).concat(Bo(e));
}
function bn(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function Wo(e, t) {
  return bn(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function Yo(e, t, s) {
  var n = {};
  return s.isMergeableObject(e) && Us(e).forEach(function(o) {
    n[o] = it(e[o], s);
  }), Us(t).forEach(function(o) {
    Wo(e, o) || (bn(e, o) && s.isMergeableObject(t[o]) ? n[o] = Qo(o, s)(e[o], t[o], s) : n[o] = it(t[o], s));
  }), n;
}
function Be(e, t, s) {
  s = s || {}, s.arrayMerge = s.arrayMerge || qo, s.isMergeableObject = s.isMergeableObject || Lo, s.cloneUnlessOtherwiseSpecified = it;
  var n = Array.isArray(t), o = Array.isArray(e), a = n === o;
  return a ? n ? s.arrayMerge(e, t, s) : Yo(e, t, s) : it(t, s);
}
Be.all = function(t, s) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, o) {
    return Be(n, o, s);
  }, {});
};
var Ko = Be, Jo = Ko;
const Rn = /* @__PURE__ */ In(Jo), Zo = (e) => e.reduce(
  (t, s) => ({
    ...t,
    [s]: !0
  }),
  {}
), ts = {
  userId: `anonymous-${ho()}`,
  isAuthenticated: !1,
  status: "initialized",
  streamIds: {},
  screenShareIds: {}
}, An = () => {
  const e = K.storage.getParsed(ve.AUTH_TOKENS);
  if (e != null && e.accessToken)
    return e;
  const t = K.storage.get(ve.DEPRECATED_TOKEN);
  if (!t)
    return;
  const s = K.storage.get(
    ve.DEPRECATED_REFRESH_TOKEN
  );
  return K.storage.set(ve.AUTH_TOKENS, {
    accessToken: t,
    refreshToken: s
  }), K.storage.remove(ve.DEPRECATED_TOKEN), K.storage.remove(ve.DEPRECATED_REFRESH_TOKEN), {
    accessToken: t,
    refreshToken: s
  };
}, ss = (e) => {
  K.storage.set(ve.AUTH_TOKENS, e), Gs({
    getAuthToken: () => e.accessToken
  });
}, Cn = () => {
  K.storage.remove(ve.AUTH_TOKENS), Gs({
    getAuthToken: () => ""
  });
}, ns = (e, t = 0) => !e || Date.now() + t * 1e3 > e * 1e3, rs = function(e, t) {
  const {
    userID: s,
    exp: n,
    roleIDs: o = []
  } = Ws(e.accessToken) || {};
  if (!(!s || ns(n, t)))
    return {
      ...e,
      userId: s,
      isAuthenticated: !0,
      expires: n,
      agentId: s,
      roles: Zo(o),
      streamIds: {},
      screenShareIds: {},
      status: "initialized"
    };
}, Xo = function(e) {
  const t = e ? Ws(e) : void 0;
  return !!t && !ns(t.exp);
}, On = async () => (await Te.logout(), Cn(), ts), ea = async function(e) {
  var u;
  if (!e)
    return;
  const t = await Hs(
    async () => Te.refreshToken({
      data: {
        refreshToken: e
      },
      throwError: !1
    })
  );
  if (t.status === 401)
    return;
  const s = (u = t.data) == null ? void 0 : u.data;
  if (!(s != null && s.authToken))
    return;
  const { authToken: n, refreshToken: o } = s, a = { accessToken: n, refreshToken: o }, i = rs(a);
  if (i)
    return ss(a), i;
};
let st;
const Nn = async function(e) {
  if (!e)
    return;
  if (st)
    return await st;
  st = ea(e);
  const t = await st;
  return st = void 0, t;
}, ta = async function(e) {
  const t = e || An();
  if (!(t != null && t.accessToken))
    return Promise.resolve(ts);
  e && ss(e);
  const s = rs(t, 180) || await Nn(t.refreshToken);
  return s || On();
}, De = {
  getAnonymous: () => ts,
  getStorageTokens: An,
  saveStorageTokens: ss,
  clearStorageTokens: Cn,
  isTokenValid: Xo,
  init: ta,
  refresh: Nn,
  decode: rs,
  logout: On,
  hasExpired: ns
}, wn = De.getAnonymous(), Un = {
  ...wn,
  status: void 0
}, sa = (e = Un, t) => Pt(e, (s) => {
  var n, o, a, i;
  switch (t.type) {
    case gn:
      return t.payload ? {
        ...t.payload,
        streamIds: e.streamIds,
        screenShareIds: e.screenShareIds
      } : wn;
    case hn:
      return s = { ...s, ...t.payload }, s;
    case fn:
      return s.currentUser = t.payload, s.userId !== ((n = t.payload) == null ? void 0 : n.id) && (s.userId = (o = t.payload) == null ? void 0 : o.id), s;
    case Sn:
      return t.payload && (s.currentUser = Rn(
        s.currentUser || {},
        t.payload
      ), t.payload.id && s.userId !== t.payload.id && (s.userId = t.payload.id)), s;
    case yn:
      return !s.currentUser || !t.payload || (s.currentUser.subscriptionPlan = t.payload), s;
    case Tn: {
      if (!t.payload.success || !((a = t.payload) != null && a.data))
        return s;
      const { streamId: u, sessionId: c, screenShareId: d } = (i = t.payload) == null ? void 0 : i.data;
      return s.streamIds[c] = u, s.screenShareIds[c] = d, s.currentUser && (s.currentUser.streamId = u, s.currentUser.screenShareId = d), s;
    }
    default:
      return e;
  }
}), W = (e) => e && e.auth ? e.auth : Un, na = (e) => W(e).isAuthenticated, ra = (e) => W(e).status, os = (e) => W(e).userId, We = (e) => W(e).currentUser, me = (e) => He(We(e), "id"), oa = (e) => He(We(e), "streamId"), Cm = (e) => He(We(e), "email"), Om = (e) => {
  const { firstName: t, lastName: s } = W(e).currentUser || {};
  return `${t} ${s}`;
}, aa = (e) => W(e).roles, Pn = (e) => He(We(e), "notificationSettings"), Nm = (e) => He(We(e), "subscriptionPlan"), wm = (e) => He(Pn(e), "isPushNotificationEnabledGlobal"), Um = (e) => W(e).streamIds, Pm = (e) => W(e).screenShareIds, Dm = (e) => He(
  Pn(e),
  "isEmailNotificationEnabledGlobal"
), km = (e) => {
  const { accessToken: t, refreshToken: s, expires: n } = W(e);
  return { accessToken: t, refreshToken: s, expires: n };
}, $m = (e) => W(e).accessToken, Mm = (e) => W(e).agentId, dt = (e) => {
  var t;
  return (t = e == null ? void 0 : e.data) == null ? void 0 : t.data;
}, Fm = (e) => dt(e.data), Lm = (e, t = 0) => {
  var s, n, o;
  return (o = (n = (s = e.data) == null ? void 0 : s.pages[t]) == null ? void 0 : n.data) == null ? void 0 : o.data;
}, ia = async (e, t, s, n, o) => {
  const a = dt(t);
  if (!a)
    throw new Error("Something went wrong");
  const { authToken: i, refreshToken: u, userSubscriptionPlan: c } = a;
  if (i) {
    const d = {
      accessToken: i,
      refreshToken: u
    }, m = await De.init(d);
    if (!m.isAuthenticated)
      throw new Error("Unauthorized");
    c && e(At(c)), m && e(Ae(m));
  } else
    c && e(At(c));
  o && o(t, s, n);
}, xm = (e) => {
  const t = Ut(), { userId: s, accessToken: n } = ae(W);
  return Vs(
    () => {
      if (!s || !n)
        throw new Error("Unauthorized");
      return wt.activateTrial(s, {
        data: { token: n }
      });
    },
    {
      ...e,
      onSuccess: (o, a, i) => ia(t, o, a, i, e.onSuccess)
    }
  );
}, jm = () => {
  const e = ae(W);
  return {
    state: e,
    isLoading: !e.status || e.status === "loading"
  };
}, Hm = () => {
  const e = Ut();
  return {
    requestOTP: (t) => e(ko(t)),
    verifyOTP: (t) => e(Mo(t)),
    verifyAuthProvider: (t) => e($o(t)),
    logout: () => e(Do())
  };
}, zm = (e) => {
  const t = ae(na), s = ae(ra), n = ae(aa), [o, a] = je(() => !e || !t ? [{}, !0] : (typeof e == "string" ? [e] : e).reduce(
    (u, c) => (u[0][c] = n && n[c], u[1] = u[1] && !!u[0][c], u),
    [{}, !0]
  ), [e, t, n]);
  return {
    isAuthenticated: t,
    status: s,
    isLoading: !s || s === "loading",
    hasAccess: a,
    access: o
  };
}, J = {
  dashboard: {
    sessions: "dashboardSessions",
    pastSessions: "dashboardPastSessions"
  },
  cmsPage: "cmsPage",
  cmsPages: "cmsPages",
  currentUser: "currentUser",
  featuredSessions: "featuredSessions",
  recording: "recording",
  recordingStatus: "recordingStatus",
  requestToShareScreen: "requestToShareScreen",
  session: "session",
  sessionAccessRule: "sessionAccessRule",
  sessionAccessRules: "sessionAccessRules",
  sessionRequestAccess: "sessionRequestAccess",
  sessionPendingRulesStats: "sessionPendingRulesStats",
  sessionEpisodes: "sessionEpisodes",
  sessionAiFeed: "sessionAiFeed",
  sessionEndSummary: "sessionEndSummary",
  sessionViewers: "sessionViewers",
  slackChannels: "slackChannels",
  slackIsAuthed: "slackIsAuthed",
  paymentDetails: "paymentDetails",
  subscriptionPlans: "subscriptionPlans",
  subscriptionReceipts: "subscriptionReceipts",
  linkPreview: "linkPreview",
  integrations: {
    providers: "providers",
    connections: "connections",
    getAction: "getAction",
    directURL: "directURL"
  },
  userMeetingTypes: "userMeetingTypes",
  devices: {
    currentCamera: "currentCamera",
    currentMicrophone: "currentMicrophone",
    currentAudio: "currentAudio"
  }
}, Ue = {
  "✅": "emojiReactions.completed",
  "❤️": "emojiReactions.love",
  "👋": "emojiReactions.hi",
  "👍": "emojiReactions.agree",
  "👎": "emojiReactions.disagree",
  "👏": "emojiReactions.celebrate",
  "😆": "emojiReactions.funny",
  "😮": "emojiReactions.wow"
}, Y = [
  "👍",
  "😆",
  "❤️",
  "👋",
  "👎",
  "👏",
  "😮",
  "✅"
], Vm = [
  {
    label: Ue[Y[0]],
    symbol: Y[0]
  },
  {
    label: Ue[Y[1]],
    symbol: Y[1]
  },
  {
    label: Ue[Y[2]],
    symbol: Y[2]
  },
  {
    label: Ue[Y[3]],
    symbol: Y[3]
  },
  {
    label: Ue[Y[4]],
    symbol: Y[4]
  },
  {
    label: Ue[Y[5]],
    symbol: Y[5]
  },
  {
    label: Ue[Y[6]],
    symbol: Y[6]
  },
  {
    label: Ue[Y[7]],
    symbol: Y[7]
  }
], Gm = "CURRENT_USER_CHIMING_IN", qm = "CURRENT_USER_CHIMING_IN_STOPPED_EVENT ", Dn = (e) => (t) => ({
  cacheTime: t,
  staleTime: t,
  retry: 2,
  //refetchOnMount: active,
  refetchOnReconnect: e,
  refetchOnWindowFocus: e
}), kn = [""], Qm = () => {
}, se = Dn(!0), ca = {
  "7d": se(6048e5),
  "3d": se(2592e5),
  "1d": se(864e5),
  "6h": se(216e5),
  "1h": se(36e5),
  "15m": se(9e5),
  "10m": se(6e5),
  "5m": se(3e5),
  "3m": se(18e4),
  "1m": se(6e4),
  "30s": se(3e4),
  "15s": se(15e3),
  "3s": se(3e3),
  0: se(0)
}, ne = Dn(!1), $n = {
  "7d": ne(6048e5),
  "3d": ne(2592e5),
  "1d": ne(864e5),
  "6h": ne(216e5),
  "1h": ne(36e5),
  "15m": ne(9e5),
  "10m": ne(6e5),
  "5m": ne(3e5),
  "3m": ne(18e4),
  "1m": ne(6e4),
  "30s": ne(3e4),
  "15s": ne(15e3),
  "3s": ne(3e3),
  0: ne(0)
}, Bm = {
  0: { type: 0, status: 2 },
  1: { type: 1, status: 2 },
  2: { type: 2, status: 1 },
  3: { type: 3, status: 1 },
  4: { type: 4, status: 1 },
  5: { type: 5, status: 1 },
  6: { type: 6, status: 1 },
  7: { type: 7, status: 1 },
  8: { type: 8 },
  9: { type: 9, status: 1, permanent: !0 },
  10: { type: 10, status: 2 },
  11: { type: 11, status: 1 },
  12: { type: 12, status: 1 },
  13: { type: 13 },
  14: { type: 14, status: 2 },
  15: { type: 15, status: 2 },
  16: { type: 16, status: 1 },
  18: { type: 17, status: 2 },
  19: { type: 18, status: 2 },
  // following are emojis
  100: { type: 100, status: 2 },
  101: { type: 101, status: 1 },
  102: { type: 102, status: 2 },
  103: { type: 103, status: 2 }
}, Wm = {
  nowUser: {
    emoji: [100, 101, 102, 103],
    text: [0, 1, 2, 3, 4, 5, 6, 7, 8]
  },
  nextUser: { emoji: [], text: [9, 16, 6, 8] },
  previousUser: { emoji: [], text: [10, 8] },
  host: {
    emoji: [100, 101, 102, 103],
    text: [0, 1, 2, 3, 4, 5, 6, 7, 13, 15, 18, 19]
  }
};
var Re = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.REQUEST = 1] = "REQUEST", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE", e))(Re || {});
const $t = (e, t) => ({
  type: nn,
  payload: t,
  meta: { actionName: e }
}), ct = (e, t) => ({
  type: rn,
  payload: t,
  meta: { actionName: e }
}), ke = (e, t) => ({
  type: on,
  payload: t,
  meta: { actionName: e }
}), ua = (e) => ({
  type: an,
  meta: { actionName: e }
}), Ym = g(cn), Mn = (e) => (t) => (s) => {
  if (t(s), !s.type.startsWith(Co))
    return;
  const [n, ...o] = s.type.split("/");
  if (o.length > 0) {
    const a = o.join("/"), i = s.payload ?? s.data, u = s.error ?? i;
    switch (n) {
      case en:
        e.dispatch($t(a, i));
        break;
      case tn:
        e.dispatch(ct(a, i));
        break;
      case sn:
        e.dispatch(ke(a, u));
        break;
    }
  }
}, Km = [Mn], la = (e) => e.actions, da = (e) => E(
  la,
  (t) => e === void 0 || t && t.name === e ? t : void 0
), Jm = (e, { onSuccess: t, onError: s } = {}) => {
  const [n, o] = Rt(), a = Ut(), i = je(
    () => da(e),
    [e]
  ), u = ae(i), c = Bs(() => {
    a(ua(e));
  }, [e, a]);
  let d;
  yo(() => {
    u && (!n || n.timestamp !== u.timestamp || n.data !== u.data) ? (d = u, o(u)) : d = void 0, d && (t && d.status === Re.SUCCESS ? t(d) === !1 && c() : s && d.status === Re.FAILURE && s(d) === !1 && c());
  }, [u]);
  const m = !!n && n.status === Re.REQUEST;
  return [n, m, c];
}, Zm = (e) => {
  const { code: t, status: s, message: n, error: o } = (e == null ? void 0 : e.data) || {};
  if (((e == null ? void 0 : e.data.success) || (e == null ? void 0 : e.status) === Re.SUCCESS) === !1) {
    const { code: i, message: u } = o || {};
    return {
      success: !1,
      code: typeof i == "number" ? i : t,
      message: u || n
    };
  }
  return {
    success: !0,
    code: s || t,
    message: n
  };
}, Xm = {
  name: "1080p",
  width: 1920,
  height: 1080,
  frameRate: 5,
  bitrateMin: 600,
  bitrateMax: 1e3,
  moveDownThreshold: 0,
  moveUpThreshold: 1e5
};
function P(e) {
  return e === co.landscape ? pa : ma;
}
function ep(e, t) {
  return P(t).find((s) => s.name === e) ?? P(t)[P(t).length - 1];
}
function tp(e, t) {
  const s = P(t).findIndex(
    (n) => n.name === e.name
  );
  return s + 1 >= P.length ? P(t)[P(t).length - 1] : P(t)[s + 1];
}
function sp(e, t) {
  const s = P(t).findIndex(
    (n) => n.name === e.name
  );
  return s - 1 < 0 ? P(t)[0] : P(t)[s - 1];
}
function Ps(e, t, s) {
  const n = P(s).findIndex(
    (a) => a.name === e.name
  ), o = P(s).findIndex(
    (a) => a.name === t.name
  );
  return n < o ? 1 : o === n ? 0 : -1;
}
const ma = [
  {
    name: "720p30",
    width: 720,
    height: 1280,
    frameRate: 30,
    bitrateMin: 750,
    moveDownThreshold: 900,
    moveUpThreshold: 1500,
    bitrateMax: 1800
  },
  {
    name: "720p",
    width: 720,
    height: 1280,
    frameRate: 15,
    bitrateMin: 400,
    moveDownThreshold: 550,
    moveUpThreshold: 1e3,
    bitrateMax: 1200
  },
  {
    name: "360p30",
    width: 360,
    height: 640,
    frameRate: 30,
    bitrateMin: 200,
    moveDownThreshold: 300,
    moveUpThreshold: 700,
    bitrateMax: 1e3
  },
  {
    name: "360p",
    width: 360,
    height: 640,
    frameRate: 15,
    bitrateMin: 120,
    moveDownThreshold: 200,
    moveUpThreshold: 500,
    bitrateMax: 500
  },
  {
    name: "240p",
    width: 240,
    height: 320,
    frameRate: 15,
    bitrateMin: 120,
    moveDownThreshold: 100,
    moveUpThreshold: 250,
    bitrateMax: 300
  },
  {
    name: "180p",
    width: 180,
    height: 320,
    bitrateMin: 80,
    bitrateMax: 300,
    frameRate: 15,
    moveDownThreshold: 80,
    moveUpThreshold: 250
  }
], pa = [
  {
    name: "720p30",
    width: 1280,
    height: 720,
    frameRate: 30,
    bitrateMin: 750,
    moveDownThreshold: 900,
    moveUpThreshold: 1500,
    bitrateMax: 1800
  },
  {
    name: "720p",
    width: 1280,
    height: 720,
    frameRate: 15,
    bitrateMin: 400,
    moveDownThreshold: 550,
    moveUpThreshold: 1e3,
    bitrateMax: 1200
  },
  {
    name: "360p30",
    width: 640,
    height: 360,
    frameRate: 30,
    bitrateMin: 200,
    moveDownThreshold: 300,
    moveUpThreshold: 700,
    bitrateMax: 1e3
  },
  {
    name: "360p",
    width: 640,
    height: 360,
    frameRate: 15,
    bitrateMin: 120,
    moveDownThreshold: 200,
    moveUpThreshold: 500,
    bitrateMax: 500
  },
  {
    name: "240p",
    width: 320,
    height: 240,
    frameRate: 15,
    bitrateMin: 120,
    moveDownThreshold: 100,
    moveUpThreshold: 250,
    bitrateMax: 300
  },
  {
    name: "180p",
    width: 320,
    height: 180,
    bitrateMin: 80,
    bitrateMax: 300,
    frameRate: 15,
    moveDownThreshold: 80,
    moveUpThreshold: 250
  }
], fa = 15;
class nt {
  constructor(t, s) {
    et(this, "maxPreset");
    et(this, "networkMonitorTimer");
    et(this, "isChangingConfig", !1);
    et(this, "configChangePromise", Promise.resolve(!0));
    this.cameraConfigurationDelegate = t, this.targetVideoOrientation = s, this.maxPreset = P(this.targetVideoOrientation)[P(this.targetVideoOrientation).length - 1];
  }
  get currentPreset() {
    return this.cameraConfigurationDelegate.currentPreset;
  }
  async setMaxPreset(t) {
    return t.name === this.maxPreset.name || (this.maxPreset = t, !this.currentPreset) || Ps(
      t,
      this.currentPreset,
      this.targetVideoOrientation
    ) > 0 ? !0 : this.setCameraConfiguration(t);
  }
  startManagingCameraQuality() {
    let t = 0;
    this.stopManagingCameraQuality(), this.networkMonitorTimer = setInterval(() => {
      const {
        targetSendBitrate: s,
        outgoingAvailableBandwidth: n,
        sendFrameRate: o
      } = this.cameraConfigurationDelegate;
      if (!nt.checkUplink(
        n,
        o,
        s,
        this.targetVideoOrientation,
        this.currentPreset
      )) {
        t = 0;
        return;
      }
      if (t++, t <= 10)
        return;
      t = 0;
      const a = this.cameraConfigurationDelegate.userVideoPreset, i = nt.optimalPresetForBitrate(
        n,
        this.targetVideoOrientation,
        a
      );
      Ps(
        i,
        this.maxPreset,
        this.targetVideoOrientation
      ) <= 0 && this.setCameraConfiguration(i);
    }, 500);
  }
  /**
   *
   * TODO: Not yet in use, reason being I am not entirely sure how to raise the preset if the CPU recovers
   * @param currentFrameRate
   * @param bitrate
   * @param currentPreset
   * @returns
   */
  static optimalPreset(t, s, n, o) {
    const a = nt.optimalPresetForFrameRate(
      t,
      n,
      o
    ), i = nt.optimalPresetForBitrate(
      s,
      o,
      n
    );
    return a && P(o).findIndex(
      (u) => a.name === u.name
    ) < P(o).findIndex(
      (u) => i.name === u.name
    ) ? a : i;
  }
  /**
   *
   * TODO: Not yet in use, reason being I am not entirely sure how to raise the preset if the CPU recovers
   * @param currentFrameRate
   * @param currentPreset
   * @returns
   */
  static optimalPresetForFrameRate(t, s, n) {
    if (t >= fa)
      return s;
    const o = P(n).findIndex(
      (a) => a.name === s.name
    );
    return o + 1 >= P(n).length ? P(n)[P(n).length - 1] : P(n)[o + 1];
  }
  static optimalPresetForBitrate(t, s, n) {
    const o = P(s).findIndex((a) => a.moveDownThreshold <= t);
    if (o < 0)
      return P(s)[P(s).length - 1];
    if (n) {
      const a = P(s).findIndex(
        (i) => i.name === n.name
      );
      if (!o || o < a)
        return n;
    }
    return P(s)[o];
  }
  static checkUplink(t, s, n, o, a) {
    const i = a ? a.moveDownThreshold : n / 1024, u = a ? a.moveUpThreshold : n / 1024;
    if (s && s < 12)
      return !0;
    if (t === 0)
      return !1;
    const c = t >= u && a !== P(o)[0], d = t < i && a !== P(o)[P(o).length - 1];
    return c || d;
  }
  stopManagingCameraQuality() {
    const t = this.networkMonitorTimer;
    t && clearInterval(t), this.networkMonitorTimer = void 0;
  }
  async setCameraConfiguration(t) {
    var s;
    return ((s = this.currentPreset) == null ? void 0 : s.name) === t.name ? !0 : this.isChangingConfig && this.configChangePromise ? this.configChangePromise : (this.isChangingConfig = !0, this.configChangePromise = new Promise(async (n, o) => {
      try {
        await this.cameraConfigurationDelegate.setCameraConfiguration(t), this.isChangingConfig = !1, n(!0);
      } catch (a) {
        const i = new uo(
          lo.SET_CAMERA_CONFIGURATION_ERROR,
          "Unable to set camera configuration",
          a
        );
        this.isChangingConfig = !1, o(i);
      }
    }), this.configChangePromise);
  }
}
var mt = function(t) {
  return "@@redux-saga/" + t;
}, Sa = /* @__PURE__ */ mt("CANCEL_PROMISE"), Fn = /* @__PURE__ */ mt("IO"), ga = /* @__PURE__ */ mt("MULTICAST"), Ds = /* @__PURE__ */ mt("SELF_CANCELLATION"), ha = /* @__PURE__ */ mt("TASK");
function Yt() {
  return Yt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var s = arguments[t];
      for (var n in s)
        Object.prototype.hasOwnProperty.call(s, n) && (e[n] = s[n]);
    }
    return e;
  }, Yt.apply(this, arguments);
}
var ya = function(t) {
  return t == null;
}, oe = function(t) {
  return t != null;
}, de = function(t) {
  return typeof t == "function";
}, as = function(t) {
  return typeof t == "string";
}, pt = Array.isArray, va = function(t) {
  return t && !pt(t) && typeof t == "object";
}, ks = function(t) {
  return t && t[ha];
}, $s = function e(t) {
  return t && (as(t) || Ta(t) || de(t) || pt(t) && t.every(e));
}, Mt = function(t) {
  return t && de(t.take) && de(t.close);
}, Ea = function(t) {
  return de(t) && t.hasOwnProperty("toString");
}, Ta = function(t) {
  return !!t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype;
}, _a = function(t) {
  return Mt(t) && t[ga];
}, Ln = function(t) {
  return t && t[Fn];
}, qt = 2147483647;
function Ia(e, t) {
  if (t === void 0 && (t = !0), process.env.NODE_ENV !== "production" && e > qt)
    throw new Error("delay only supports a maximum value of " + qt + "ms");
  var s, n = new Promise(function(o) {
    s = setTimeout(o, Math.min(qt, e), t);
  });
  return n[Sa] = function() {
    clearTimeout(s);
  }, n;
}
process.env.NODE_ENV !== "production" && typeof Proxy < "u";
var ba = function(t) {
  return t;
};
function V(e, t, s) {
  if (!t(e))
    throw new Error(s);
}
var Ra = function(t) {
  throw t;
}, Aa = function(t) {
  return {
    value: t,
    done: !0
  };
};
function Ca(e, t, s) {
  t === void 0 && (t = Ra), s === void 0 && (s = "iterator");
  var n = {
    meta: {
      name: s
    },
    next: e,
    throw: t,
    return: Aa,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (n[Symbol.iterator] = function() {
    return n;
  }), n;
}
var Qt = "TAKE", Oa = "PUT", Na = "CALL", is = "FORK", wa = "CANCEL", Ua = "SELECT", Ms = `
(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)`, Ce = function(t, s) {
  var n;
  return n = {}, n[Fn] = !0, n.combinator = !1, n.type = t, n.payload = s, n;
}, Pa = function(t) {
  return Ln(t) && t.type === is;
}, Da = function(t) {
  return process.env.NODE_ENV !== "production" && V(t, Pa, "detach(eff): argument must be a fork effect"), Ce(is, Yt({}, t.payload, {
    detached: !0
  }));
};
function ka(e, t) {
  if (e === void 0 && (e = "*"), process.env.NODE_ENV !== "production" && arguments.length && V(arguments[0], oe, "take(patternOrChannel): patternOrChannel is undefined"), $s(e))
    return oe(t) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), Ce(Qt, {
      pattern: e
    });
  if (_a(e) && oe(t) && $s(t))
    return Ce(Qt, {
      channel: e,
      pattern: t
    });
  if (Mt(e))
    return oe(t) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), Ce(Qt, {
      channel: e
    });
  if (process.env.NODE_ENV !== "production")
    throw new Error("take(patternOrChannel): argument " + e + " is not valid channel or a valid pattern");
}
function b(e, t) {
  return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? (V(e, oe, "put(channel, action): argument channel is undefined"), V(e, Mt, "put(channel, action): argument " + e + " is not a valid channel"), V(t, oe, "put(channel, action): argument action is undefined")) : V(e, oe, "put(action): argument action is undefined")), ya(t) && (t = e, e = void 0), Ce(Oa, {
    channel: e,
    action: t
  });
}
var cs = function(t, s) {
  if (V(s, oe, t + ": argument fn is undefined or null"), !de(s)) {
    var n = null, o;
    if (pt(s))
      n = s[0], o = s[1], V(o, oe, t + ": argument of type [context, fn] has undefined or null `fn`");
    else if (va(s))
      n = s.context, o = s.fn, V(o, oe, t + ": argument of type {context, fn} has undefined or null `fn`");
    else {
      V(s, de, t + ": argument fn is not function");
      return;
    }
    if (n && as(o)) {
      V(n[o], de, t + ': context arguments has no such method - "' + o + '"');
      return;
    }
    V(o, de, t + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};
function xn(e, t) {
  var s = null, n;
  return de(e) ? n = e : (pt(e) ? (s = e[0], n = e[1]) : (s = e.context, n = e.fn), s && as(n) && de(s[n]) && (n = s[n])), {
    context: s,
    fn: n,
    args: t
  };
}
var $a = function(t) {
  return t !== Fa;
};
function Q(e) {
  for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    s[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var o = typeof s[0] == "number" ? s[0] : "ms";
    V(e, $a, "instead of writing `yield call(delay, " + o + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + o + ")`"), cs("call", e);
  }
  return Ce(Na, xn(e, s));
}
function qe(e) {
  process.env.NODE_ENV !== "production" && (cs("fork", e), V(e, function(o) {
    return !Ln(o);
  }, "fork: argument must not be an effect"));
  for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    s[n - 1] = arguments[n];
  return Ce(is, xn(e, s));
}
function Kt(e) {
  process.env.NODE_ENV !== "production" && cs("spawn", e);
  for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    s[n - 1] = arguments[n];
  return Da(qe.apply(void 0, [e].concat(s)));
}
function Ma(e) {
  if (e === void 0 && (e = Ds), process.env.NODE_ENV !== "production") {
    if (arguments.length > 1)
      throw new Error("cancel(...tasks) is not supported any more. Please use cancel([...tasks]) to cancel multiple tasks.");
    pt(e) ? e.forEach(function(t) {
      V(t, ks, "cancel([...tasks]): argument " + t + " is not a valid Task object " + Ms);
    }) : e !== Ds && oe(e) && V(e, ks, "cancel(task): argument " + e + " is not a valid Task object " + Ms);
  }
  return Ce(wa, e);
}
function ut(e) {
  e === void 0 && (e = ba);
  for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    s[n - 1] = arguments[n];
  return process.env.NODE_ENV !== "production" && arguments.length && (V(arguments[0], oe, "select(selector, [...]): argument selector is undefined"), V(e, de, "select(selector, [...]): argument " + e + " is not a function")), Ce(Ua, {
    selector: e,
    args: s
  });
}
var Fa = /* @__PURE__ */ Q.bind(null, Ia), Fs = function(t) {
  return {
    done: !0,
    value: t
  };
}, Bt = {};
function La(e) {
  return Mt(e) ? "channel" : Ea(e) ? String(e) : de(e) ? e.name : String(e);
}
function xa(e, t, s) {
  var n, o, a, i = t;
  function u(c, d) {
    if (i === Bt)
      return Fs(c);
    if (d && !o)
      throw i = Bt, d;
    n && n(c);
    var m = d ? e[o](d) : e[i]();
    return i = m.nextState, a = m.effect, n = m.stateUpdater, o = m.errorState, i === Bt ? Fs(c) : a;
  }
  return Ca(u, function(c) {
    return u(null, c);
  }, s);
}
function ja(e, t) {
  for (var s = arguments.length, n = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)
    n[o - 2] = arguments[o];
  var a = {
    done: !1,
    value: ka(e)
  }, i = function(N) {
    return {
      done: !1,
      value: qe.apply(void 0, [t].concat(n, [N]))
    };
  }, u = function(N) {
    return {
      done: !1,
      value: Ma(N)
    };
  }, c, d, m = function(N) {
    return c = N;
  }, R = function(N) {
    return d = N;
  };
  return xa({
    q1: function() {
      return {
        nextState: "q2",
        effect: a,
        stateUpdater: R
      };
    },
    q2: function() {
      return c ? {
        nextState: "q3",
        effect: u(c)
      } : {
        nextState: "q1",
        effect: i(d),
        stateUpdater: m
      };
    },
    q3: function() {
      return {
        nextState: "q1",
        effect: i(d),
        stateUpdater: m
      };
    }
  }, "q1", "takeLatest(" + La(e) + ", " + t.name + ")");
}
var Ha = function(t, s, n) {
  V(s, oe, t.name + " requires a pattern or channel"), V(n, oe, t.name + " requires a saga parameter");
};
function Pe(e, t) {
  process.env.NODE_ENV !== "production" && Ha(Pe, e, t);
  for (var s = arguments.length, n = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)
    n[o - 2] = arguments[o];
  return qe.apply(void 0, [ja, e, t].concat(n));
}
const jn = "app/NAVIGATE_TO", us = g(jn), Ct = ({
  client: e,
  key: t,
  fn: s,
  skipEmpty: n
}) => {
  const o = e.getQueryData(t);
  n && o === void 0 || e.setQueryData(t, s(o));
}, Tt = (e) => Ct({
  ...e,
  fn: (t) => ({
    code: 200,
    success: !0,
    ...t,
    data: zs(e.dataOrFn) ? e.dataOrFn(t == null ? void 0 : t.data) : e.dataOrFn
  })
}), _e = {
  update: Tt,
  addToArray: (e) => Tt({
    ...e,
    dataOrFn: (t) => [...e.data, ...t || []]
  }),
  updateInArray: ({
    data: e,
    keyId: t,
    ...s
  }) => Tt({
    ...s,
    dataOrFn: (n) => n == null ? void 0 : n.map((o) => o[t] === e[t] ? e : o)
  }),
  removeFromArray: ({
    id: e,
    keyId: t,
    ...s
  }) => Tt({
    ...s,
    dataOrFn: (n) => n == null ? void 0 : n.filter((o) => o[t] !== e)
  }),
  addToPages: (e) => Ct({
    ...e,
    fn: (t) => {
      var n;
      const s = {
        pageParams: [...(t == null ? void 0 : t.pageParams) || []],
        pages: [...(t == null ? void 0 : t.pages) || []]
      };
      return s.pages[0] = {
        ...s.pages[0],
        data: {
          code: 200,
          success: !0,
          ...s.pages[0].data,
          data: e.updateFn((n = s.pages[0].data) == null ? void 0 : n.data)
        }
      }, s;
    }
  }),
  updateInPages: (e) => Ct({
    ...e,
    fn: (t) => {
      var n, o;
      if (!t || !((n = t.pages) != null && n.length))
        return t;
      const s = {
        pageParams: [...t.pageParams],
        pages: [...t.pages]
      };
      for (let a = 0; a < s.pages.length; a++) {
        const i = (o = s.pages[a]) == null ? void 0 : o.data, u = i == null ? void 0 : i.data;
        if (!u)
          continue;
        const c = e.updateFn(u);
        if (i !== c && (s.pages[a] = {
          ...s.pages[a],
          data: {
            ...i,
            data: c
          }
        }, e.stopOnChange))
          break;
      }
      return s;
    }
  })
}, za = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  request: _e,
  update: Ct
}, Symbol.toStringTag, { value: "Module" })), Va = {
  add: ({
    client: e,
    data: t,
    sessionId: s,
    recurrenceId: n
  }) => {
    t && _e.addToArray({
      client: e,
      key: [
        J.sessionAiFeed,
        s,
        n
      ],
      data: [t]
    });
  },
  update: ({
    client: e,
    data: t,
    sessionId: s,
    recurrenceId: n
  }) => {
    t && _e.update({
      client: e,
      key: [
        J.sessionAiFeed,
        s,
        n
      ],
      dataOrFn: (o) => o ? (o.messages = o.messages.map(
        (a) => a.id === t.id ? t : a
      ), o) : { messages: [t], totalSummaryCount: 1 }
    });
  },
  remove: ({
    client: e,
    sessionId: t,
    recurrenceId: s,
    id: n
  }) => {
    _e.removeFromArray({
      client: e,
      key: [
        J.sessionAiFeed,
        t,
        s
      ],
      id: n,
      keyId: "id"
    });
  }
}, Ga = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aiFeed: Va
}, Symbol.toStringTag, { value: "Module" })), qa = {
  add: ({ client: e, data: t, userId: s }) => {
    t && _e.addToPages({
      client: e,
      key: [
        J.dashboard.sessions,
        "pg",
        s
      ],
      updateFn: (n) => ({
        ...n,
        count: ((n == null ? void 0 : n.count) || 0) + 1,
        sessions: [t, ...(n == null ? void 0 : n.sessions) || []]
      })
    });
  },
  update: ({ client: e, data: t, userId: s }) => {
    t && _e.updateInPages({
      client: e,
      key: [
        J.dashboard.sessions,
        "pg",
        s
      ],
      stopOnChange: !0,
      updateFn: (n) => {
        if (!(n != null && n.sessions))
          return n;
        const o = n.sessions.findIndex(
          (i) => i.sessionID === t.sessionID
        );
        if (o === -1)
          return n;
        const a = {
          ...n,
          sessions: [...n.sessions]
        };
        return a.sessions[o] = t, a;
      }
    });
  },
  remove: ({
    client: e,
    userId: t,
    id: s
  }) => {
    let n;
    return _e.updateInPages({
      client: e,
      key: [
        J.dashboard.sessions,
        "pg",
        t
      ],
      stopOnChange: !0,
      updateFn: (o) => {
        if (!(o != null && o.sessions))
          return o;
        const a = o.sessions.findIndex((u) => u.sessionID === s);
        if (a === -1)
          return o;
        const i = { ...o, sessions: [...o.sessions] };
        return i.count = Math.max(0, (i.count || 1) - 1), n = i.sessions.splice(a, 1)[0], i;
      }
    }), n;
  }
}, Qa = {
  add: ({ client: e, data: t = [] }) => {
    if (!t.length)
      return;
    const { sessionID: s, sessionRecurrenceID: n } = t[0];
    _e.update({
      client: e,
      key: [
        J.sessionAccessRules,
        s,
        n,
        vt.GRANTED
      ],
      dataOrFn: (o = {}) => {
        var R, C;
        const a = { ...o }, i = (N, j) => (j.type === "domain" ? N[0].push(j) : N[1].push(j), N), [u, c] = ((C = (R = a == null ? void 0 : a.data) == null ? void 0 : R.viewerAccessRules) == null ? void 0 : C.reduce(i, [[], []])) || [], [d, m] = t.reduce(i, [[], []]);
        return {
          data: {
            viewerAccessRules: [
              ...d,
              ...u || [],
              ...m,
              ...c || []
            ]
          }
        };
      }
    });
  },
  remove: ({
    client: e,
    sessionId: t,
    sessionRecurrenceId: s,
    id: n
  }) => {
    _e.update({
      client: e,
      key: [
        J.sessionAccessRules,
        t,
        s,
        vt.GRANTED
      ],
      dataOrFn: (o) => {
        var i;
        const a = ((i = o == null ? void 0 : o.data.viewerAccessRules) == null ? void 0 : i.filter((u) => u.id !== n)) || [];
        return {
          ...o,
          data: {
            ...o == null ? void 0 : o.data,
            viewerAccessRules: a
          }
        };
      }
    });
  },
  // requests
  addRequest: ({
    client: e,
    sessionId: t,
    sessionRecurrenceId: s,
    data: n
  }) => {
    const o = [
      J.sessionRequestAccess,
      t,
      s,
      vt.IN_REVIEW
    ], i = { ...e.getQueryData(o) };
    if (!i.pages || !i.pages.length || !i.pages[0].data) {
      e.invalidateQueries(o);
      return;
    }
    i.pages[0].data.data.accessRules = [
      ...n,
      ...i.pages[0].data.data.accessRules || []
    ], e.setQueryData(o, i);
  },
  removeRequest: ({
    client: e,
    sessionId: t,
    sessionRecurrenceId: s,
    id: n
  }) => {
    const o = [
      J.sessionRequestAccess,
      t,
      s,
      vt.IN_REVIEW
    ];
    let a;
    return _e.updateInPages({
      client: e,
      key: o,
      stopOnChange: !0,
      updateFn: (i) => {
        if (!(i != null && i.accessRules))
          return i;
        const u = i.accessRules.findIndex((d) => d.id === n);
        if (u === -1)
          return i;
        const c = {
          ...i,
          accessRules: [...i.accessRules]
        };
        return c.totalCount = Math.max(0, (c.totalCount || 1) - 1), a = c.accessRules.splice(u, 1)[0], c;
      }
    }), a;
  }
}, Ba = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  session: qa,
  sessionViewerAccess: Qa
}, Symbol.toStringTag, { value: "Module" })), Wa = {
  ...za,
  ...Ba,
  ...Ga
}, Ya = 50, Ka = (e, t = "") => !e || !e.firstName && !e.fullName && !e.userFirstName && !e.userLastName ? t : e.fullName ? e.fullName : `${e.firstName || e.userFirstName} ${e.lastName || e.userLastName || ""}`, np = (e, t) => `${e}${t ? ` ${t}` : ""}`, rp = (e, t = "") => {
  var o, a;
  if (!e || !e.firstName && !e.fullName && !e.userFirstName && !e.userLastName)
    return t;
  const s = e.firstName || e.userFirstName || "", n = ((o = e.lastName) == null ? void 0 : o.charAt(0)) || ((a = e.userLastName) == null ? void 0 : a.charAt(0)) || "";
  return `${s} ${n}`;
}, Ja = (e) => e && {
  ...e,
  fullName: Ka(e)
}, Hn = (e) => e && e.map((t) => Ja(t)), op = (e, t) => !!e && !!t && e.id === t.id, ap = (e) => ({
  id: e.id,
  firstName: "Anonymous",
  fullName: "Anonymous",
  streamId: e.streamId,
  screenShareId: e.streamId
}), zn = "UPDATE_VIEW_COUNT", Za = "app/SessionContainer/SETUP_CURRENT_SESSION", Xa = "app/SessionContainer/SETUP_CURRENT_SESSION_RESPONSE", Vn = "app/SessionContainer/SET_CURRENT_SESSION", Gn = "app/SessionContainer/SET_ACTIVE_SESSION", qn = "app/SessionContainer/SET_BOTH_SESSIONS", Qn = "app/SessionContainer/SET_CURRENT_SESSION_STATE", ei = "app/SessionContainer/JOIN_SESSION", ti = "app/SessionContainer/START_SESSION", Bn = "app/SessionContainer/END_SESSION", Wn = "app/SessionContainer/SET_SESSION_STATUS", Yn = "app/SessionContainer/SET_SESSION", Kn = "app/SessionContainer/CLEAR_SESSION", Jn = "app/SessionContainer/START_SCREEN_SHARING", Zn = "app/SessionContainer/INIT_SCREEN_SHARING", Xn = "app/SessionContainer/STOP_SCREEN_SHARING", er = "app/SessionContainer/GUEST_IS_READY_STREAM", tr = "app/SessionContainer/UPDATE_CURRENT_SESSION", si = "app/SessionContainer/SESSION_ACCESS_GRANTED", sr = "app/SessionContainer/SET_QUEUE", nr = "app/SessionContainer/HOST_ENTERED_SESSION", ni = "app/SessionContainer/GUEST_READY", ri = "app/SessionContainer/GUEST_UP_NEXT", ip = "app/SessionContainer/GUEST_ON_AIR", cp = "app/SessionContainer/ACTIVE_GUESTS", rr = "app/SessionContainer/SET_SESSION_QUEUE_STATUS", or = "app/SessionContainer/SET_SESSION_MODAL", ar = "app/SessionContainer/CLOSE_SESSION_MODAL", oi = "app/SessionContainer/SHOW_SURVEY", ai = "app/SessionContainer/REMOVE_FROM_SESSION_QUEUE", ii = "app/SessionContainer/REMOVE_FROM_SESSION_QUEUE_SUCCESS", ci = "app/SessionContainer/GUEST_TO_HOST_CONNECT", ui = "app/SessionContainer/HOST_TO_GUEST_CONNECT", ir = "app/SessionContainer/SET_FEATURED_SESSIONS", cr = "app/SessionContainer/SET_FEATURED_SESSION", ur = "app/SessionContainer/CANCEL_INTERRUPT_SESSION", lr = "app/SessionContainer/INTERRUPT_SESSION", li = "app/SessionContainer/REQUEST_SESSION_FOCUS", di = "app/SessionContainer/CHECK_INTERRUPT_SESSION", up = "app/SessionContainer/ON_AIR_SOUND_EFFECT_PLAYED", lp = "app/SessionContainer/RESET_ON_AIR_SOUND_EFFECT_PLAYED", dr = "app/SessionContainer/SET_COUNTDOWN", mr = "app/SessionContainer/SET_SESSION_ROLE_PRESENCE", pr = "app/SessionContainer/SET_INDIVIDUAL_EMOJI_REACTIONS", fr = "app/SessionContainer/CLEAR_INDIVIDUAL_EMOJI_REACTIONS", mi = "app/SessionContainer/REQUEST_CHIME_IN", Sr = "app/SessionContainer/UPDATE_CHIMED_IN_USERS", gr = "app/SessionContainer/GRANT_CONSENT_TO_BROADCAST", hr = "app/SessionContainer/REVOKE_CONSENT_TO_BROADCAST", pi = "app/SessionContainer/CHECK_SESSION_ACCESS", yr = "app/SessionContainer/SET_OFF_THE_RECORD_STATUS", vr = "app/SessionContainer/UPDATE_USER_MEDIA", Er = "app/SessionContainer/SET_STREAM_FALLBACK", fi = (e, t) => {
  if (t)
    return e && t.find((s) => e === s.id) || t[0];
}, dp = (e) => e ? fi(e.primaryHostUserID, e.hosts) : void 0, Si = (e) => e === Nt.IN_SESSION, Tr = (e, t) => e.stateUpdatedAt.find((s) => s.state === t), mp = (e) => {
  var t;
  return (t = Tr(e, Nt.IN_SESSION)) == null ? void 0 : t.updatedAt;
}, pp = (e) => {
  var t;
  return (t = Tr(e, Nt.ENDED)) == null ? void 0 : t.updatedAt;
}, fp = (e, t) => (e == null ? void 0 : e.primaryHostUserID) === (t == null ? void 0 : t.id) && (t == null ? void 0 : t.id) !== void 0, re = {
  current: {
    data: {}
  },
  active: {
    data: {},
    queue: {
      status: F.NONE,
      users: []
    },
    reactions: {},
    chimeIn: {
      users: []
    },
    consentToBroadcast: !1,
    offTheRecordStatus: !1
  },
  allMap: {},
  summaryMap: {},
  featured: void 0,
  interrupted: {},
  presence: {},
  modal: {}
}, _t = (e) => {
  const t = Xs(
    Hn(e.hosts),
    e.primaryHostUserID
  );
  return {
    ...e,
    hosts: t
  };
}, Sp = (e = re, t) => Pt(e, (s) => {
  var n;
  switch (t.type) {
    case Wn:
      if (t.payload) {
        const { sessionId: c, status: d } = t.payload;
        s.allMap[c] && (s.allMap[c].sessionState = d), s.summaryMap[c] && (s.summaryMap[c].sessionState = d), s.active.id === c && !Si(d) && (s.active = re.active);
      }
      break;
    case Yn:
      t.payload && (s.allMap[t.payload.sessionID] = _t(t.payload));
      break;
    case Kn:
      t.payload && (delete s.allMap[t.payload], s.active.id === t.payload && (s.active = re.active), s.current.id === t.payload && (s.current = re.current));
      break;
    case lr:
      s.interrupted[t.payload.sessionId] = !0;
      break;
    case ur:
      delete s.interrupted[t.payload.sessionId];
      break;
    case Vn:
      t.payload ? typeof t.payload == "string" ? (s.current.id = t.payload, s.current.loading = void 0) : (s.current.id = t.payload.sessionID, s.allMap[t.payload.sessionID] = _t(t.payload), s.current.loading = void 0) : s.current = re.current;
      break;
    case Gn:
      t.payload ? typeof t.payload == "string" ? s.active.id = t.payload : (s.active.id = t.payload.sessionID, s.allMap[t.payload.sessionID] = _t(t.payload)) : s.active = re.active;
      break;
    case qn:
      t.payload ? typeof t.payload == "string" ? (s.current.id = t.payload, s.active.id = t.payload, s.current.loading = void 0) : (s.current.id = t.payload.sessionID, s.active.id = t.payload.sessionID, s.allMap[t.payload.sessionID] = _t(t.payload), s.current.loading = void 0) : (s.current = re.current, s.active = re.active);
      break;
    case Qn:
      s.current = {
        ...s.current,
        ...t.payload,
        requestData: t.payload.requestData
      };
      break;
    case tr:
      const { sessionID: o, ...a } = t.payload || {};
      t.payload.sessionID && (s.allMap[o] = Rn(
        s.allMap[o],
        a,
        {
          // TODO: issue with deepMerge - https://github.com/TehShrike/deepmerge/issues/264
          arrayMerge: (c, d) => c.length > 0 ? c : d
        }
      ), a.hosts && (s.allMap[o].hosts = Xs(
        Hn(a.hosts),
        a.primaryHostUserID || s.allMap[o].primaryHostUserID
      )));
      break;
    case Bn:
      s.active.queue = re.active.queue, s.presence = re.presence;
      break;
    case sr:
      if (s.active.queue = s.active.queue || {
        users: [],
        status: F.NONE
      }, t.payload) {
        const [c, ...d] = t.payload, { now: m } = s.active.queue;
        c ? (!m || c.id !== m.id) && (s.active.queue.now = c) : s.active.queue.now = void 0, s.active.queue.users = d;
      }
      break;
    case rr:
      if (s.active.queue || (s.active.queue = re.active.queue), t.payload === F.PAUSED && s.active.queue.status === F.HALTED)
        break;
      s.active.queue.status = t.payload ?? F.NONE, t.payload === F.HALTED && (s.active.data.liveGuestStreamId = void 0);
      break;
    case dr:
      t.payload && t.payload.status === mo.PAUSED && (s.active.queue.status = F.HALTED);
      break;
    case nr:
      const { hostId: i } = t.payload || {};
      i && (s.current.data.hostPresence = {
        ...s.current.data.hostPresence,
        [i]: !0
      });
      break;
    case zn:
      s.active.data.viewCount = t.payload ?? e.active.data.viewCount;
      break;
    case or:
      s.modal = t.payload || {};
      break;
    case ar:
      s.modal.type === t.payload && (s.modal = {});
      break;
    case Zn:
      const { data: u } = t.payload;
      if (!u.screen_shares || u.screen_shares.length === 0)
        return;
      s.active.data.liveScreenShareDetails = {
        id: u.screen_shares[0].uID,
        details: {
          userID: u.screen_shares[0].userID,
          streamID: u.screen_shares[0].mainUID
        },
        sessionID: u.sessionID,
        screenShareID: u.screen_shares[0].uID
      };
      break;
    case Jn:
      s.active.data.liveScreenShareDetails = {
        id: t.payload.screenShareID,
        details: t.payload.details,
        sessionID: t.payload.sessionID,
        screenShareID: t.payload.screenShareID
      };
      break;
    case Xn:
      s.active.data.liveScreenShareDetails = void 0;
      break;
    case er:
      s.active.data.liveGuestStreamId = t.payload.streamId;
      break;
    case ir:
      t.payload && t.payload && (s.featured = vo(t.payload, "sessionID"));
      break;
    case cr:
      if (t.payload && s.featured) {
        const { sessionID: c, sessionState: d } = t.payload;
        s.featured.entities[c] && (s.featured.entities[c].sessionState = d);
      }
      break;
    case mr:
      t.payload && (s.presence[t.payload.role] = t.payload.presence_list.reduce(
        (c, { data: d, is_host: m }) => (d && (c[d.id] = { ...d, isHost: m }), c),
        {}
      ));
      break;
    case pr:
      t.payload && (s.active.reactions = Object.keys(t.payload).reduce(
        (c, d) => ({
          ...c,
          [d]: { ...t.payload[d], timestamp: Date.now() }
        }),
        {}
      ), s.active.reactions = t.payload);
      break;
    case Sr:
      t.payload && (s.active.chimeIn.users = t.payload.chimedInUsers);
      break;
    case fr:
      t.payload && ((n = s.active.reactions) != null && n[t.payload]) && delete s.active.reactions[t.payload];
      break;
    case gr: {
      s.active.consentToBroadcast = !0;
      break;
    }
    case hr: {
      s.active.consentToBroadcast = !1;
      break;
    }
    case yr:
      t.payload && (s.active.offTheRecordStatus = t.payload.data.off_the_record_status);
      break;
    case vr: {
      s.active.data.userMedia === void 0 && (s.active.data.userMedia = {});
      const { streamId: c, mediaType: d, isActive: m } = t.payload, R = s.active.data.userMedia[c] || {
        audio: !1,
        video: !1,
        streamId: c
      };
      s.active.data.userMedia[c] = {
        ...R,
        [d]: m
      };
      break;
    }
    case Er: {
      s.active.data.streamFallback === void 0 && (s.active.data.streamFallback = {});
      const { streamId: c, isAudioOnly: d } = t.payload, m = s.active.data.streamFallback[c] || {
        streamId: c,
        isAudioOnly: !1
      };
      s.active.data.streamFallback[c] = {
        ...m,
        isAudioOnly: d
      };
      break;
    }
  }
}), G = (e) => e.sessions || re, _r = (e) => G(e).allMap, gp = (e, t) => G(e).allMap[t], hp = (e, t) => !!G(e).allMap[t], gi = (e) => G(e).interrupted, yp = (e) => G(e).featured, vp = (e) => {
  var t;
  return (t = G(e).featured) == null ? void 0 : t.ids;
}, Ep = (e, t) => {
  var s;
  return (s = G(e).featured) == null ? void 0 : s.entities[t];
}, Tp = (e) => G(e).modal, Ir = (e) => G(e).presence, _p = (e, t) => E(
  [Ir],
  (s) => !!t && !!s[e] && !!s[e][t]
), br = (e) => E(
  [Ir, e],
  (t, s) => t && s ? t[fo(s)] : void 0
), Rr = (e, t) => E(
  [e, We, t],
  (s, n, o) => {
    if (!s)
      return [];
    const a = n && !o ? {
      id: n.id,
      firstName: n.firstName,
      lastName: n.lastName,
      avatar: n.avatar,
      nftAvatar: n.nftAvatar,
      isHost: !1
    } : void 0;
    let i = -1;
    const c = Object.keys(s).slice(0, Ya).map((d, m) => (a && d === a.id && (i = m), s[d]));
    return a && i >= 0 && (c.splice(i, 1), c.unshift(a)), c;
  }
), Ip = (e) => {
  const { id: t, loading: s, error: n, requestData: o } = G(e).current;
  return {
    id: t,
    loading: s,
    error: n,
    requestData: o
  };
}, ls = (e) => G(e).current.id, bp = (e) => {
  var t;
  return (t = ee(e)) == null ? void 0 : t.sessionRecurrenceID;
}, ee = E(
  ls,
  _r,
  (e, t) => e ? t[e] : void 0
), Rp = (e) => {
  const t = ee(e);
  if (t)
    return {
      id: t.sessionID,
      recurrenceId: t.sessionRecurrenceID,
      title: t.sessionTitle,
      about: t.about,
      cover: t.cover
    };
}, Ap = (e) => {
  const t = ee(e);
  return t ? t.branchURL || t.publicURL : void 0;
}, Cp = (e) => {
  var t;
  return (t = ee(e)) == null ? void 0 : t.subscriptionPlan;
}, Op = (e) => {
  var t;
  return (t = ee(e)) == null ? void 0 : t.sessionSettings;
}, Np = (e) => {
  const t = ee(e);
  return t ? [t.startTimestamp, t.endTimestamp] : [void 0, void 0];
}, wp = (e) => {
  var t;
  return (t = ee(e)) == null ? void 0 : t.sessionState;
}, Up = (e) => {
  const t = ee(e);
  if (t)
    return {
      id: t.sessionID,
      recurrenceId: t.sessionRecurrenceID,
      title: t.sessionTitle,
      about: t.about,
      cover: t.cover
    };
}, hi = (e) => {
  var t;
  return (t = ee(e)) == null ? void 0 : t.hosts;
}, Pp = (e) => G(e).current.data || re.current.data, yi = E(
  [hi, me],
  (e = [], t) => !!t && e.some((s) => s.id === t)
), Dp = E(
  [ee, me],
  (e, t) => (e == null ? void 0 : e.primaryHostUserID) === t
), vi = br(
  ls
), Ar = Rr(
  vi,
  yi
), kp = E(
  [Ar],
  (e) => e.filter((t) => t.isHost)
), $p = E(
  [Ar],
  (e) => e.filter((t) => !t.isHost)
), Mp = E(
  [ee, me],
  (e, t) => (e == null ? void 0 : e.primaryHostUserID) === t
), Fp = E(
  [ee],
  (e) => e == null ? void 0 : e.hosts.find((t) => t.id === e.primaryHostUserID)
), Lp = E(
  [ee],
  (e) => e && es(e) || void 0
), Ei = E(
  [ee],
  (e) => (e == null ? void 0 : e.hostUserIDs.length) || 0
), xp = E(
  [Ei],
  (e) => e >= K.session.maxSpeakers
);
let lt;
function* Ti({ payload: e }) {
  yield b($t(rt, e));
  const t = K.getFingerPrint ? yield Q(() => K.getFingerPrint) : void 0, {
    email: s,
    firstName: n,
    lastName: o,
    isSignup: a = !1,
    marketingOptIn: i,
    redirectUrl: u,
    clientId: c
  } = e ?? {}, d = {
    email: s.toLowerCase(),
    firstName: n,
    lastName: o,
    marketingOptIn: i,
    isSignup: a,
    fingerprint: t
  }, m = c && u ? yield Q(Te.requestOAuthOTP, {
    data: {
      ...d,
      redirect_uri: u,
      client_id: c
    }
  }) : yield Q(Te.requestOTP, {
    data: d
  });
  yield b(
    m.success ? ct(rt, e) : ke(rt, (m == null ? void 0 : m.data) || m)
  );
}
function* _i({ payload: e }) {
  var u;
  yield b($t(Ee, e)), yield b(Ae({ status: "loading" }));
  const { email: t, otp: s, clientId: n, ...o } = e ?? {}, { sessionID: a } = (yield ut(ee)) ?? {};
  if (n) {
    const c = yield Q(Te.verifyOAuthOTP, {
      data: {
        email: t.toLowerCase(),
        otp: s,
        client_id: n
      }
    }), { redirect_uri: d } = ((u = c.data) == null ? void 0 : u.data) || {};
    yield b(Ae({ status: "initialized" })), c.success && d ? (yield b(ct(Ee, c)), yield b(us(d))) : yield b(ke(Ee, c));
    return;
  }
  const i = yield Q(Te.verifyOTP, {
    data: {
      email: t.toLowerCase(),
      otp: s
    }
  });
  if (i.success && i.data && i.data.data) {
    const { authToken: c, refreshToken: d } = i.data.data;
    yield b(ct(Ee, i)), yield ds(
      _n({
        accessToken: c,
        refreshToken: d,
        sessionID: a,
        ...o
      })
    );
  } else
    yield b(ke(Ee, i)), yield b(Ae({ status: "initialized" }));
}
function* Ii({
  payload: e
}) {
  var c;
  const { token: t, code: s, type: n, userDetails: o, clientId: a, redirectUrl: i } = e;
  if (!n || !s && !t)
    return;
  if (yield b(Ae({ status: "loading" })), yield b($t(ot, e)), a && i) {
    const d = t ? yield Q(Te.verifyOAuthTokenProvider, {
      data: {
        token: t,
        type: n,
        userDetails: o,
        client_id: a,
        redirect_uri: i
      }
    }) : yield Q(Te.verifyOAuthCodeProvider, {
      data: {
        code: s || "",
        type: n,
        client_id: a,
        redirect_uri: i
      }
    }), { redirect_uri: m } = ((c = d.data) == null ? void 0 : c.data) || {};
    yield b(Ae({ status: "initialized" })), d.success && m ? yield b(us(m)) : yield b(ke(ot, d));
    return;
  }
  const u = t ? yield Q(Te.verifyAuthTokenProvider, {
    data: { token: t, type: n, userDetails: o }
  }) : yield Q(Te.verifyAuthCodeProvider, {
    data: { code: s || "", type: n }
  });
  if (u.success && u.data && u.data.data) {
    const { authToken: d, refreshToken: m } = u.data.data;
    yield ds(
      _n({
        accessToken: d,
        refreshToken: m
      })
    );
  } else
    yield b(ke(ot, u)), yield b(Ae({ status: "initialized" }));
}
function* ds({ payload: e }) {
  const { accessToken: t, refreshToken: s, onCompleted: n, redirectUrl: o } = e, a = yield Q(De.init, {
    accessToken: t,
    refreshToken: s
  });
  a.refreshToken && (yield Kt(Ft, a)), a.isAuthenticated && (yield Kt(Ot)), yield b(Qe(a)), yield b(Dt()), yield b(Ae({ status: "initialized" })), n ? zs(n) ? n.constructor.name === "GeneratorFunction" ? yield* n() : yield n() : yield b(n) : o && (yield b(us(o)));
}
function* Jt() {
  lt && clearTimeout(lt), yield b(Ae({ status: "loading" })), yield Q(De.logout), yield b(Qe(De.getAnonymous())), yield b(kt());
}
let Wt = 0;
function* bi() {
  var s, n;
  const e = yield Q(
    () => Hs(() => wt.getCurrent({ throwError: !1 }), 3)
  );
  if (e && e.status === 401) {
    if (Wt > 0) {
      yield b(ke(xe, e)), yield* Jt(), Wt = 0;
      return;
    }
    Wt++;
    const o = yield ut(W), a = yield Q(Cr, 0, o);
    yield b(Qe(a)), yield b(a.isAuthenticated ? Dt() : kt()), a.isAuthenticated && (yield qe(Ft, a), yield qe(Ot));
    return;
  }
  const t = (n = (s = e.data) == null ? void 0 : s.data) == null ? void 0 : n.user;
  if (t) {
    const o = {
      id: t.userID,
      firstName: t.userFirstName,
      lastName: t.userLastName,
      ...t
    }, i = { ...yield ut(W), currentUser: o };
    yield b(Qe(i)), yield b(ct(xe, o)), yield qe(Ot);
    return;
  }
  yield b(ke(xe, e)), yield* Jt();
}
const Cr = (e, t) => new Promise(async (s) => {
  lt = setTimeout(async () => {
    const o = await De.refresh(t.refreshToken) || await De.logout();
    return s(o);
  }, e);
});
function* Ft(e) {
  lt && clearTimeout(lt);
  const { expires: t, refreshToken: s } = e;
  if (!t || !s)
    return;
  const n = Math.floor(18e4 + Math.random() * 18e4), o = Math.max(0, t * 1e3 - Date.now() - n), a = yield Q(Cr, o, e);
  yield b(Qe(a)), yield b(a.isAuthenticated ? Dt() : kt()), a.isAuthenticated && (yield* Ft(a));
}
const Ri = 6e5;
let Zt;
const Ai = (e) => new Promise(async (t) => {
  Zt = setTimeout(async () => {
    const s = await wt.getSubscriptionPlan(e);
    return t(s);
  }, Ri);
});
function* Ot() {
  Zt && clearTimeout(Zt);
  const e = yield ut(W);
  if (!e.isAuthenticated || !e.userId)
    return;
  const t = yield Q(
    Ai,
    e.userId
  ), s = dt(t);
  s && t.success && (yield b(At(s))), yield* Ot();
}
function* Ci() {
  const e = yield ut(W);
  if (!e.isAuthenticated || !e.userId)
    return;
  const t = yield Q(
    wt.getSubscriptionPlan,
    e.userId
  ), s = dt(t);
  s && t.success && (yield b(At(s)));
}
function* Oi() {
  const e = yield Q(De.init);
  e.refreshToken && (yield Kt(Ft, e)), yield b(Qe(e)), yield b(e.isAuthenticated ? Dt() : kt());
}
function* jp() {
  yield Pe(pn, ds), yield Pe(vn, Ci), yield Pe(En, bi), yield Pe(mn, Jt), yield Pe(rt, Ti), yield Pe(Ee, _i), yield Pe(ot, Ii), yield Q(Oi);
}
const Hp = {
  has: (e) => {
    const t = K.featureFlags;
    return !!t && (t[e] === !0 || t[e] === "true");
  }
}, Or = "SET_MODAL", zp = g(Or), Ni = {
  type: void 0,
  props: {}
}, wi = (e = Ni, t) => Pt(e, () => {
  switch (t.type) {
    case Or:
      return t.payload || {};
    default:
      return;
  }
}), Vp = (e) => e.modal, Ui = {}, Pi = (e = Ui, { type: t, payload: s }) => {
  switch (t) {
    case jn:
      return typeof s == "string" ? {
        path: s
      } : s || {};
    default:
      return e;
  }
}, Gp = (e) => e.navigation;
var Di = /* @__PURE__ */ ((e) => (e[e.HOST = 1] = "HOST", e[e.TOPIC = 2] = "TOPIC", e[e.HOW_IT_WORKS = 3] = "HOW_IT_WORKS", e[e.CAM_MIC_PERMISSIONS = 4] = "CAM_MIC_PERMISSIONS", e[e.TEST_DEVICES = 5] = "TEST_DEVICES", e[e.INTERRUPTED = 6] = "INTERRUPTED", e[e.VIEWER_ACCESS = 7] = "VIEWER_ACCESS", e[e.CO_HOST_REQUEST = 8] = "CO_HOST_REQUEST", e[e.REQUEST_CO_HOST = 9] = "REQUEST_CO_HOST", e[e.ADD_CO_HOSTS = 10] = "ADD_CO_HOSTS", e[e.STOP_HOSTING = 11] = "STOP_HOSTING", e[e.START_HOSTING = 12] = "START_HOSTING", e[e.USER_MEETING_TYPE = 13] = "USER_MEETING_TYPE", e))(Di || {});
const qp = g(Zn), Qp = g(Jn), Bp = g(Xn), Wp = g(lr), Yp = g(di), Kp = g(ur), Jp = g(Bn), ki = g(li), Zp = g(Wn), Xp = g(rr), ef = g(oi), tf = g(ai), sf = g(ii), nf = g(Za), rf = g(Vn), of = g(qn), af = g(Gn), cf = g(si), uf = g(Yn), lf = g(Kn), df = g(Xa), mf = g(tr), pf = (e) => ({
  type: or,
  payload: e
}), ff = (e) => ({
  type: ar,
  payload: e
}), Sf = g(ei), gf = g(ti), hf = g(sr), yf = g(nr), vf = g(ni), Ef = g(ri), Tf = g(er), _f = g(zn), If = g(ci), bf = g(ui), Rf = g(ir), Af = g(cr), Cf = g(dr), Of = g(mr), Nf = g(Qn), wf = g(pr), Uf = g(mi), Pf = g(Sr), Df = g(fr), kf = g(gr), $f = g(hr), Mf = g(pi), Ff = g(vr), Lf = g(yr), xf = g(Er), ms = (e) => G(e).active.id, ie = E(
  ms,
  _r,
  (e, t) => e ? t[e] : void 0
), jf = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.sessionRecurrenceID;
}, Hf = E(
  [ie],
  (e) => {
    if (e)
      return {
        id: e.sessionID,
        recurrenceId: e.sessionRecurrenceID,
        title: e.sessionTitle,
        about: e.about,
        cover: e.cover
      };
  }
), zf = E(
  [ie],
  (e) => e ? [e.startTimestamp, e.endTimestamp] : [void 0, void 0]
), Vf = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.subscriptionPlan;
}, Gf = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.sessionState;
}, qf = (e) => {
  const t = ie(e);
  return t ? t.branchURL || t.publicURL : void 0;
}, Lt = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.hosts;
}, Ye = (e) => G(e).active.chimeIn.users || [], $i = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.producers;
}, Ke = (e) => G(e).active.data || re.active.data, Nr = (e) => Ke(e).liveScreenShareDetails, Mi = (e) => {
  var t;
  return (t = ie(e)) == null ? void 0 : t.sessionSettings;
}, ft = (e) => G(e).active.queue, Oe = (e) => ft(e).now, Fi = (e) => !!ft(e).now, xt = (e) => ft(e).users ?? [], Li = (e) => {
  var t;
  return (t = xt(e)) == null ? void 0 : t[0];
}, St = (e) => ft(e).status ?? F.NONE, Qf = (e) => !!xt(e).length || !!Oe(e), wr = (e) => Ke(e).viewCount, Bf = (e) => (wr(e) || 0) > 0, Wf = (e) => {
  const t = Oe(e), s = Ke(e).liveGuestStreamId;
  return !!t && t.streamId === s;
}, Yf = E(
  [ie, me],
  (e, t) => (e == null ? void 0 : e.primaryHostUserID) === t
), ps = E(
  [Lt, me],
  (e = [], t) => !!t && e.some((s) => s.id === t)
), Kf = E(
  [Ye, me],
  (e = [], t) => !!t && e.some((s) => s.id === t)
), xi = E(
  [ie],
  (e) => e && es(e) || void 0
), ji = E(
  [Oe, me, St],
  (e, t, s) => !!e && e.id === t && (s === F.RUNNING || s === F.PAUSED)
), Hi = E(
  [xt, Fi],
  (e, t) => e.length + (t ? 1 : 0)
), Jf = E(
  Hi,
  (e) => e > 0
), zi = E(
  [Oe, me, xt],
  (e, t, s) => {
    if (e && e.id === t)
      return -1;
    if (s.length > 0 && t) {
      const n = s.findIndex((o) => o.id === t);
      return n >= 0 ? n : void 0;
    }
  }
), Zf = E(
  [zi],
  (e) => e !== void 0
), Vi = (e) => G(e).active.consentToBroadcast, Xf = E(
  [
    me,
    ps,
    Oe,
    Vi,
    xi
  ],
  (e, t, s, n, o) => (
    // isOrganizer ||
    t && o === bt.QueueMode || t && n || !!s && e === s.id
  )
), eS = E(
  [
    Mi,
    ps,
    ji,
    St
  ],
  (e, t, s, n) => !(e != null && e.oneOnOne) || t || s && (n === F.RUNNING || n === F.PAUSED)
), Ur = E(
  [
    Lt,
    $i,
    Oe,
    Nr
  ],
  (e = [], t = [], s, n) => {
    const { screenShareID: o, details: a } = n || {};
    return !(a != null && a.userID) || !o ? [] : [...e, ...t, s].filter(
      (u) => (u == null ? void 0 : u.id) === a.userID
    ).map((u) => ({
      ...u,
      screenShareId: o
    }));
  }
), tS = E(
  [me, Ur],
  (e, t) => t.some((s) => s.id === e)
), sS = E(
  [Nr],
  (e) => {
    var t;
    return ((t = e == null ? void 0 : e.details) == null ? void 0 : t.streamID) !== void 0;
  }
), Gi = E(
  [
    Lt,
    Oe,
    St,
    Ur,
    Ye
  ],
  (e = [], t, s, n, o) => {
    const a = (s === F.RUNNING || s === F.PAUSED) && t, i = (s === F.NONE || s === F.HALTED) && t, u = a ? [t] : [], c = i ? [i] : [];
    return {
      hosts: e,
      guests: u,
      preview: c,
      screens: n,
      chimeIns: o,
      all: e.concat(u).concat(c).concat(o).concat(n)
    };
  }
), nS = E(
  [
    Gi,
    Ye,
    oa
  ],
  (e, t, s) => e.all.some((n) => n.streamId === s) || t.some((n) => n.streamId === s)
), rS = E(
  [Oe, Li, St],
  (e, t, s) => {
    if (s === F.NONE || s === F.HALTED)
      return e;
    if (s === F.RUNNING || s === F.PAUSED)
      return t;
  }
), oS = E(
  [Ye],
  (e) => e.length
), aS = E(
  [Ye],
  (e) => !!(e && e.length > 0)
), iS = E(
  [
    Lt,
    Oe,
    Ye,
    St
  ],
  (e = [], t, s = [], n) => {
    const o = (n === F.RUNNING || n === F.PAUSED) && !!t;
    return { hosts: e, chimeIns: s, guests: o ? [t] : [] };
  }
), qi = E(
  gi,
  ie,
  (e, t) => !!t && Eo(t) && !!e[t.sessionID]
), cS = (e) => G(e).active.reactions, uS = (e, t) => {
  const s = G(e).active.reactions;
  return s ? s[t] : void 0;
}, Qi = br(
  ms
), Pr = Rr(
  Qi,
  ps
), Bi = E(
  [Pr],
  (e) => e.filter((t) => t.isHost)
), lS = E(
  [Pr],
  (e) => e.filter((t) => !t.isHost)
), Dr = E(
  [ie],
  (e) => (e == null ? void 0 : e.hostUserIDs.length) || 0
), dS = E(
  [Dr],
  (e) => e >= K.session.maxSpeakers
), mS = E(
  [wr, Dr],
  (e = 1, t) => e - t
), pS = E(
  [ft],
  (e) => {
    var s;
    if (!e.now)
      return [];
    const t = [];
    return e.now.isBot && t.push(e.now), t.concat(((s = e.users) == null ? void 0 : s.filter((n) => n.isBot)) || []);
  }
), Wi = E(
  [ie],
  (e) => e == null ? void 0 : e.hosts.find((t) => t.id === e.primaryHostUserID)
), fS = E(
  [Wi, Bi],
  (e, t) => t.some((s) => s.id === (e == null ? void 0 : e.id))
), SS = (e) => G(e).active.offTheRecordStatus, gS = (e) => E([Ke], (t) => {
  var s;
  return !e || t.userMedia === void 0 ? !1 : ((s = t.userMedia[e]) == null ? void 0 : s[js.Video]) || !1;
}), hS = (e) => E([Ke], (t) => {
  var s;
  return !e || t.userMedia === void 0 ? !1 : ((s = t.userMedia[e]) == null ? void 0 : s[js.Audio]) || !1;
}), yS = (e) => E([Ke], (t) => {
  var s;
  return !e || t.streamFallback === void 0 ? !1 : ((s = t.streamFallback[e]) == null ? void 0 : s.isAudioOnly) || !1;
}), vS = "sessions", ES = [
  "free",
  "premium",
  "pro",
  "enterprise"
], TS = {
  free: ["meetings", "timeLimit", "queueMode", "integrations", "stream"],
  premium: [
    "aiFeed",
    "recording",
    "integrations",
    "stream",
    "aiFeedLocal",
    "meetingSummary",
    "offTheRecord",
    "support"
  ],
  pro: void 0,
  enterprise: void 0
};
var kr = { exports: {} };
(function(e, t) {
  (function(s, n) {
    e.exports = n();
  })(Fo, function() {
    var s = 1e3, n = 6e4, o = 36e5, a = "millisecond", i = "second", u = "minute", c = "hour", d = "day", m = "week", R = "month", C = "quarter", N = "year", j = "date", $e = "Invalid Date", Je = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Se = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, H = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(v) {
      var S = ["th", "st", "nd", "rd"], p = v % 100;
      return "[" + v + (S[(p - 20) % 10] || S[p] || S[0]) + "]";
    } }, Me = function(v, S, p) {
      var y = String(v);
      return !y || y.length >= S ? v : "" + Array(S + 1 - y.length).join(p) + v;
    }, Ze = { s: Me, z: function(v) {
      var S = -v.utcOffset(), p = Math.abs(S), y = Math.floor(p / 60), h = p % 60;
      return (S <= 0 ? "+" : "-") + Me(y, 2, "0") + ":" + Me(h, 2, "0");
    }, m: function v(S, p) {
      if (S.date() < p.date())
        return -v(p, S);
      var y = 12 * (p.year() - S.year()) + (p.month() - S.month()), h = S.clone().add(y, R), _ = p - h < 0, I = S.clone().add(y + (_ ? -1 : 1), R);
      return +(-(y + (p - h) / (_ ? h - I : I - h)) || 0);
    }, a: function(v) {
      return v < 0 ? Math.ceil(v) || 0 : Math.floor(v);
    }, p: function(v) {
      return { M: R, y: N, w: m, d, D: j, h: c, m: u, s: i, ms: a, Q: C }[v] || String(v || "").toLowerCase().replace(/s$/, "");
    }, u: function(v) {
      return v === void 0;
    } }, Ne = "en", ce = {};
    ce[Ne] = H;
    var Z = "$isDayjsObject", Fe = function(v) {
      return v instanceof Le || !(!v || !v[Z]);
    }, Ie = function v(S, p, y) {
      var h;
      if (!S)
        return Ne;
      if (typeof S == "string") {
        var _ = S.toLowerCase();
        ce[_] && (h = _), p && (ce[_] = p, h = _);
        var I = S.split("-");
        if (!h && I.length > 1)
          return v(I[0]);
      } else {
        var D = S.name;
        ce[D] = S, h = D;
      }
      return !y && h && (Ne = h), h || !y && Ne;
    }, M = function(v, S) {
      if (Fe(v))
        return v.clone();
      var p = typeof S == "object" ? S : {};
      return p.date = v, p.args = arguments, new Le(p);
    }, U = Ze;
    U.l = Ie, U.i = Fe, U.w = function(v, S) {
      return M(v, { locale: S.$L, utc: S.$u, x: S.$x, $offset: S.$offset });
    };
    var Le = function() {
      function v(p) {
        this.$L = Ie(p.locale, null, !0), this.parse(p), this.$x = this.$x || p.x || {}, this[Z] = !0;
      }
      var S = v.prototype;
      return S.parse = function(p) {
        this.$d = function(y) {
          var h = y.date, _ = y.utc;
          if (h === null)
            return /* @__PURE__ */ new Date(NaN);
          if (U.u(h))
            return /* @__PURE__ */ new Date();
          if (h instanceof Date)
            return new Date(h);
          if (typeof h == "string" && !/Z$/i.test(h)) {
            var I = h.match(Je);
            if (I) {
              var D = I[2] - 1 || 0, $ = (I[7] || "0").substring(0, 3);
              return _ ? new Date(Date.UTC(I[1], D, I[3] || 1, I[4] || 0, I[5] || 0, I[6] || 0, $)) : new Date(I[1], D, I[3] || 1, I[4] || 0, I[5] || 0, I[6] || 0, $);
            }
          }
          return new Date(h);
        }(p), this.init();
      }, S.init = function() {
        var p = this.$d;
        this.$y = p.getFullYear(), this.$M = p.getMonth(), this.$D = p.getDate(), this.$W = p.getDay(), this.$H = p.getHours(), this.$m = p.getMinutes(), this.$s = p.getSeconds(), this.$ms = p.getMilliseconds();
      }, S.$utils = function() {
        return U;
      }, S.isValid = function() {
        return this.$d.toString() !== $e;
      }, S.isSame = function(p, y) {
        var h = M(p);
        return this.startOf(y) <= h && h <= this.endOf(y);
      }, S.isAfter = function(p, y) {
        return M(p) < this.startOf(y);
      }, S.isBefore = function(p, y) {
        return this.endOf(y) < M(p);
      }, S.$g = function(p, y, h) {
        return U.u(p) ? this[y] : this.set(h, p);
      }, S.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, S.valueOf = function() {
        return this.$d.getTime();
      }, S.startOf = function(p, y) {
        var h = this, _ = !!U.u(y) || y, I = U.p(p), D = function(fe, q) {
          var ye = U.w(h.$u ? Date.UTC(h.$y, q, fe) : new Date(h.$y, q, fe), h);
          return _ ? ye : ye.endOf(d);
        }, $ = function(fe, q) {
          return U.w(h.toDate()[fe].apply(h.toDate("s"), (_ ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(q)), h);
        }, L = this.$W, B = this.$M, te = this.$D, ge = "set" + (this.$u ? "UTC" : "");
        switch (I) {
          case N:
            return _ ? D(1, 0) : D(31, 11);
          case R:
            return _ ? D(1, B) : D(0, B + 1);
          case m:
            var pe = this.$locale().weekStart || 0, he = (L < pe ? L + 7 : L) - pe;
            return D(_ ? te - he : te + (6 - he), B);
          case d:
          case j:
            return $(ge + "Hours", 0);
          case c:
            return $(ge + "Minutes", 1);
          case u:
            return $(ge + "Seconds", 2);
          case i:
            return $(ge + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, S.endOf = function(p) {
        return this.startOf(p, !1);
      }, S.$set = function(p, y) {
        var h, _ = U.p(p), I = "set" + (this.$u ? "UTC" : ""), D = (h = {}, h[d] = I + "Date", h[j] = I + "Date", h[R] = I + "Month", h[N] = I + "FullYear", h[c] = I + "Hours", h[u] = I + "Minutes", h[i] = I + "Seconds", h[a] = I + "Milliseconds", h)[_], $ = _ === d ? this.$D + (y - this.$W) : y;
        if (_ === R || _ === N) {
          var L = this.clone().set(j, 1);
          L.$d[D]($), L.init(), this.$d = L.set(j, Math.min(this.$D, L.daysInMonth())).$d;
        } else
          D && this.$d[D]($);
        return this.init(), this;
      }, S.set = function(p, y) {
        return this.clone().$set(p, y);
      }, S.get = function(p) {
        return this[U.p(p)]();
      }, S.add = function(p, y) {
        var h, _ = this;
        p = Number(p);
        var I = U.p(y), D = function(B) {
          var te = M(_);
          return U.w(te.date(te.date() + Math.round(B * p)), _);
        };
        if (I === R)
          return this.set(R, this.$M + p);
        if (I === N)
          return this.set(N, this.$y + p);
        if (I === d)
          return D(1);
        if (I === m)
          return D(7);
        var $ = (h = {}, h[u] = n, h[c] = o, h[i] = s, h)[I] || 1, L = this.$d.getTime() + p * $;
        return U.w(L, this);
      }, S.subtract = function(p, y) {
        return this.add(-1 * p, y);
      }, S.format = function(p) {
        var y = this, h = this.$locale();
        if (!this.isValid())
          return h.invalidDate || $e;
        var _ = p || "YYYY-MM-DDTHH:mm:ssZ", I = U.z(this), D = this.$H, $ = this.$m, L = this.$M, B = h.weekdays, te = h.months, ge = h.meridiem, pe = function(q, ye, we, ze) {
          return q && (q[ye] || q(y, _)) || we[ye].slice(0, ze);
        }, he = function(q) {
          return U.s(D % 12 || 12, q, "0");
        }, fe = ge || function(q, ye, we) {
          var ze = q < 12 ? "AM" : "PM";
          return we ? ze.toLowerCase() : ze;
        };
        return _.replace(Se, function(q, ye) {
          return ye || function(we) {
            switch (we) {
              case "YY":
                return String(y.$y).slice(-2);
              case "YYYY":
                return U.s(y.$y, 4, "0");
              case "M":
                return L + 1;
              case "MM":
                return U.s(L + 1, 2, "0");
              case "MMM":
                return pe(h.monthsShort, L, te, 3);
              case "MMMM":
                return pe(te, L);
              case "D":
                return y.$D;
              case "DD":
                return U.s(y.$D, 2, "0");
              case "d":
                return String(y.$W);
              case "dd":
                return pe(h.weekdaysMin, y.$W, B, 2);
              case "ddd":
                return pe(h.weekdaysShort, y.$W, B, 3);
              case "dddd":
                return B[y.$W];
              case "H":
                return String(D);
              case "HH":
                return U.s(D, 2, "0");
              case "h":
                return he(1);
              case "hh":
                return he(2);
              case "a":
                return fe(D, $, !0);
              case "A":
                return fe(D, $, !1);
              case "m":
                return String($);
              case "mm":
                return U.s($, 2, "0");
              case "s":
                return String(y.$s);
              case "ss":
                return U.s(y.$s, 2, "0");
              case "SSS":
                return U.s(y.$ms, 3, "0");
              case "Z":
                return I;
            }
            return null;
          }(q) || I.replace(":", "");
        });
      }, S.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, S.diff = function(p, y, h) {
        var _, I = this, D = U.p(y), $ = M(p), L = ($.utcOffset() - this.utcOffset()) * n, B = this - $, te = function() {
          return U.m(I, $);
        };
        switch (D) {
          case N:
            _ = te() / 12;
            break;
          case R:
            _ = te();
            break;
          case C:
            _ = te() / 3;
            break;
          case m:
            _ = (B - L) / 6048e5;
            break;
          case d:
            _ = (B - L) / 864e5;
            break;
          case c:
            _ = B / o;
            break;
          case u:
            _ = B / n;
            break;
          case i:
            _ = B / s;
            break;
          default:
            _ = B;
        }
        return h ? _ : U.a(_);
      }, S.daysInMonth = function() {
        return this.endOf(R).$D;
      }, S.$locale = function() {
        return ce[this.$L];
      }, S.locale = function(p, y) {
        if (!p)
          return this.$L;
        var h = this.clone(), _ = Ie(p, y, !0);
        return _ && (h.$L = _), h;
      }, S.clone = function() {
        return U.w(this.$d, this);
      }, S.toDate = function() {
        return new Date(this.valueOf());
      }, S.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, S.toISOString = function() {
        return this.$d.toISOString();
      }, S.toString = function() {
        return this.$d.toUTCString();
      }, v;
    }(), ue = Le.prototype;
    return M.prototype = ue, [["$ms", a], ["$s", i], ["$m", u], ["$H", c], ["$W", d], ["$M", R], ["$y", N], ["$D", j]].forEach(function(v) {
      ue[v[1]] = function(S) {
        return this.$g(S, v[0], v[1]);
      };
    }), M.extend = function(v, S) {
      return v.$i || (v(S, Le, M), v.$i = !0), M;
    }, M.locale = Ie, M.isDayjs = Fe, M.unix = function(v) {
      return M(1e3 * v);
    }, M.en = ce[Ne], M.Ls = ce, M.p = {}, M;
  });
})(kr);
var Yi = kr.exports;
const Ls = /* @__PURE__ */ In(Yi), _S = 100, Ki = (e) => {
  var t;
  return !!e && ((t = e.scheduledChange) == null ? void 0 : t.action) === "cancel";
}, IS = (e) => !e || e === "free", Ji = (e) => !e || e.planConfig.paddleProductName === "free", Zi = (e) => !!e && e.status === "trialing", Xi = (e) => Zi(e) && !(e != null && e.nextBilledAt) && !Ki(e), bS = (e) => Ji(e) || Xi(e), $r = (e, t) => {
  var s, n;
  return e ? ((s = e.planConfigOverrides) == null ? void 0 : s[t]) || ((n = e.planConfig) == null ? void 0 : n[t]) : void 0;
}, RS = (e, t) => {
  var s;
  return !!((s = $r(e, t)) != null && s.enabled);
}, AS = (e, t) => {
  var s;
  return !((s = $r(e, t)) != null && s.enabled);
}, CS = (e) => e && e.status === "trialing" && e.trialEndsAt ? Math.max(
  Math.ceil(Ls.unix(e.trialEndsAt).diff(Ls(), "hour") / 24),
  0
) : 0, ec = (e, t) => {
  var s;
  return (s = e == null ? void 0 : e.prices) == null ? void 0 : s.find(
    (n) => {
      var o;
      return ((o = n.billingCycle) == null ? void 0 : o.interval) === t && n.status !== "archived";
    }
  );
}, OS = (e, t) => {
  if (e)
    for (let s = 0; s < e.length; s++) {
      const n = ec(e[s], t);
      if (n)
        return n;
    }
}, NS = (e) => {
  var t;
  return e ? ["error", "action_required"].includes((t = e.lastPayment) == null ? void 0 : t.status) : !1;
}, Mr = "app/user/SET_USER", tc = "app/user/GET_USER", wS = g(Mr), US = g(
  tc
), Fr = {
  all: {}
}, sc = (e = Fr, t) => Pt(e, (s) => {
  switch (t.type) {
    case Mr:
      t.payload && (s.all[t.payload.data.id] = t.payload.data);
      break;
  }
}), nc = (e) => e.users ?? Fr, rc = (e) => nc(e).all, PS = (e) => E([rc], (t) => t ? t[e] : void 0), DS = "users", kS = ({
  isEnabled: e = !0
}) => {
  var ce;
  const t = ae(me), s = !!t && e, {
    data: n,
    isSuccess: o,
    error: a,
    isLoading: i
  } = at(
    s ? [J.integrations.connections, t] : kn,
    () => Os.getConnections({ throwError: !0 }),
    {
      enabled: s,
      ...ca["5m"],
      staleTime: 1e4
    }
  ), u = dt(n), c = K.storage.getParsed(
    ve.LAST_USED_INTEGRATION
  ), d = (Z) => K.storage.set(ve.LAST_USED_INTEGRATION, Z);
  je(() => {
    !u || !c || Zs(
      c,
      u
    ) || d(void 0);
  }, [u, c]);
  const [m, R] = Rt(), [C, N] = Rt(), j = je(() => [
    J.integrations.getAction,
    C,
    m == null ? void 0 : m.providerName,
    m == null ? void 0 : m.actionName
  ], [C, m]), {
    data: $e,
    isSuccess: Je,
    isFetching: Se,
    refetch: H
  } = at(
    j,
    ({ queryKey: Z }) => {
      const [, Fe, Ie = "", M = ""] = Z;
      return Os.getAction(Ie, M, {
        params: { aiFeedItemId: Fe },
        throwError: !0
      });
    },
    {
      enabled: !1
    }
  ), Me = (Z) => {
    R(Z), d(Z), N(Z.aiSessionFeedMessageId);
  };
  go(() => {
    m && H();
  }, [m, H]);
  const Ze = Xt();
  return {
    providerCategories: u,
    errorProviderCategories: a,
    isFetchingProviderCategories: i,
    isSuccessProviderCategories: o,
    selectedIntegration: m,
    lastUsedIntegration: c,
    onClickProvider: Me,
    onClickConnect: async () => new Promise((Z) => {
      setTimeout(() => {
        Ze.invalidateQueries({
          queryKey: [J.integrations.connections, t]
        }), Z(!0);
      }, 3e3);
    }),
    blockKitSchema: !!$e && Je && ((ce = $e.data) == null ? void 0 : ce.data.schema) || void 0,
    isFetchingGetAction: Se,
    selectedSessionFeedMessageId: C
  };
}, $S = (e) => {
  const t = ae(os);
  return je(() => [...e, t || ""], [e, t]);
}, MS = ({
  key: e,
  options: t
}) => {
  const s = ae(os);
  return je(
    () => ({
      key: [...e, s || ""],
      options: {
        ...t,
        enabled: (t == null ? void 0 : t.enabled) !== !1 && !!s
      },
      userId: s
    }),
    [e, t, s]
  );
}, FS = (e, t, s) => {
  const n = ae(os);
  return at([...e, n || ""], t, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...s,
    enabled: (s == null ? void 0 : s.enabled) !== !1 && !!n
  });
}, LS = (e, t, s) => at(
  [J.sessionAiFeed, e, t],
  async () => {
    var n;
    return (n = await qs.getFeed(e, t, {
      params: {
        limit: 100,
        sortOrder: "asc"
      }
    })) == null ? void 0 : n.data;
  },
  {
    ...$n["5m"],
    ...s
  }
), xS = () => {
  const e = Ut(), t = ae(ms), s = ae(ls), n = ae(qi), o = t || s, a = Bs(() => {
    o && e(ki({ sessionId: o }));
  }, [o, e]);
  return {
    isSessionInterrupted: n,
    takeSessionFocus: a
  };
}, It = [
  J.sessionPendingRulesStats
], jS = ({
  sessions: e,
  enabled: t = !0
}) => {
  const s = ae(me), n = Xt(), [o, a] = Rt(
    n.getQueryData(It) || {}
  ), i = je(() => {
    if (!e || !s)
      return;
    const d = n.getQueryData(It), m = e.reduce(
      (R, C) => (C.isViewerAccessRestricted && (!d || !d[Cs([C.sessionID, C.sessionRecurrenceID])]) && C.primaryHostUserID === s && R.push({
        id: C.sessionID,
        recurrenceID: C.sessionRecurrenceID
      }), R),
      []
    );
    return m.length > 0 ? m : void 0;
  }, [n, s, e]), u = t !== !1 && !!i;
  return { query: at(
    u ? [
      J.sessionPendingRulesStats,
      i
    ] : kn,
    i ? () => So.getInReviewViewerAccessStats({
      data: {
        sessions: i
      },
      throwError: !0
    }) : () => null,
    {
      enabled: u,
      onSuccess: (d) => {
        const { data: m } = (d == null ? void 0 : d.data) || {};
        !m || !Array.isArray(m) || a((R) => {
          const C = m.reduce((N, j) => (j && (N[Cs([j.id, j.recurrenceID])] = j.count || 0), N), R);
          return n.setQueryData(It, C), n.setQueryDefaults(It, $n["5m"]), C;
        });
      }
    }
  ), rules: o };
}, HS = ({
  id: e,
  sessionId: t,
  recurrenceId: s
}, n) => {
  const o = Xt();
  return Vs(
    (a) => qs.updateFeed(e, {
      throwError: !0,
      data: {
        ...a,
        sessionID: t,
        sessionRecurrenceID: s
      }
    }),
    {
      ...n,
      onSuccess: (...a) => {
        var u, c;
        const i = (c = (u = a[0]) == null ? void 0 : u.data) == null ? void 0 : c.data;
        i && (Wa.aiFeed.update({
          client: o,
          data: i,
          sessionId: t,
          recurrenceId: s
        }), n != null && n.onSuccess && n.onSuccess(...a));
      }
    }
  );
}, oc = () => (e) => (t) => {
  t.type.startsWith(Oo) && (t.timestamp = Date.now()), e(t);
}, zS = [oc, Mn], xs = null, ac = (e = xs, { type: t, payload: s, timestamp: n, meta: o }) => {
  const { actionName: a = t } = o || {};
  switch (t) {
    case nn:
      return {
        name: a,
        status: Re.REQUEST,
        data: s,
        timestamp: n
      };
    case rn:
      return {
        name: a,
        status: Re.SUCCESS,
        data: s,
        timestamp: n
      };
    case on:
      return {
        name: a,
        status: Re.FAILURE,
        data: s,
        timestamp: n
      };
    case an:
      return {
        name: a,
        status: Re.NONE,
        data: void 0,
        timestamp: n
      };
    case cn:
      return xs;
    default:
      return e;
  }
}, VS = {
  auth: sa,
  modal: wi,
  actions: ac,
  navigation: Pi,
  users: sc
}, ic = "Agree", cc = "Celebrate", uc = "Completed", lc = "Disagree", dc = "Funny", mc = "Hi", pc = "Love", fc = "Wow", Sc = {
  agree: ic,
  celebrate: cc,
  completed: uc,
  disagree: lc,
  funny: dc,
  hi: mc,
  love: pc,
  wow: fc
}, gc = "Connect $t(_company) to other tools you use", hc = "Connect another account", yc = "Disconnect account", vc = "Connect more integrations", Ec = "Active connections", Tc = "Integrated platform", _c = "Category", Ic = "Compatibility", bc = "Revoke access", Rc = {
  ticketing: "Ticketing",
  ticketingDesc: "Effectively handle and track tasks that come out of your meetings.",
  messaging: "Messaging",
  messagingDesc: "Boosts team communication by sending real-time updates straight from your meetings.",
  scheduling: "Scheduling",
  schedulingDesc: "Easily schedule and create Rumi meeting links in with one click, synced with your calendar."
}, Ac = "Insight", Cc = "Action item", Oc = {
  "logged-ticket-private": "{{name}} logged this",
  view: "View",
  "view-ticket": "View ticket",
  meeting: "Meeting",
  "shared-private": "{{name}} shared this",
  "logged-ticket-public": "{{name}} logged this",
  "shared-public": "{{name}} logged this",
  "crated-meeting-public": "{{name}} has shared a meeting",
  "crated-meeting-private": "{{name}} created a meeting"
}, Nc = {
  label: "Google Calendar add-on",
  desc: "Schedule and invite others to Rumi meetings with one click, straight from your calendar"
}, wc = {
  label: "Google Chrome extension",
  desc: "Quickly access & start Rumi meetings and easily add meeting links to Google Calendar"
}, Uc = {
  "unableToSendTo{integration}": "Unable to send to {{integration}}. Something unexpectedly went wrong. Please try again."
}, Pc = {
  connect_companyToOtherToolsYouUse: gc,
  connectAnotherAccount: hc,
  disconnectAccount: yc,
  connectMoreIntegrations: vc,
  activeConnections: Ec,
  integratedPlatform: Tc,
  category: _c,
  compatibility: Ic,
  revokeAccess: bc,
  "revokeAccessDescription{connection}": "Are you sure you want to revoke access for {{connection}}",
  categories: Rc,
  "catch-up": "Catch-up",
  insight: Ac,
  actionItem: Cc,
  link: Oc,
  gCal: Nc,
  gChrome: wc,
  errors: Uc
}, Dc = {
  guestSkippedSelf: "{{name}} skipped themselves",
  hostSkippedGuest: "{{name}} was skipped",
  messageCode: {
    0: "⭐️ <span/> You're doing <em>great!</em>",
    1: "👍 <span/> We <em>hear</em> & see you",
    2: "☎️ <span/> Can't <em>hear</em> you",
    3: "🔴 <span/> Can't <em>see</em> you",
    4: "🔇 <span/> Please <em>mute</em> yourself",
    5: "📢 <span/> Fix your <em>audio</em>",
    6: "💡 <span/> Fix your <em>lighting</em>",
    7: "🔄 <span/> <em>Refresh</em> your browser",
    8: "💪 <span/> Please <em>rejoin</em> the queue",
    9: "⚠️ <span/>  Test <em>cam & sound</em>",
    10: "⭐️ <span/> You were <em>great!</em>",
    11: "🎧 <span/> Try to fix your <em>audio</em>",
    12: "💡 <span/> Try to fix your <em>lighting</em>",
    13: "🎯 <span/> <em>Ask people</em> to join",
    14: "⭐️ <span/> Looking <em>great!</em>",
    15: "👀 <span/> Check <em>your phone</em>",
    16: "🔴 <span/> <em>Your video</em> is faulty",
    17: "<span/> You're next",
    18: "⏸ <span/> <em>I paused</em> the queue",
    19: "▶️ <span/> You need to <em>click resume</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "Failed to send message",
  botsAddedToQueue: "Bots were added to the queue"
}, kc = {
  session: Dc
}, $c = "Action timed out. Please check your internet connection and try again.", Mc = {
  400: "This email address is not registered on $t(_company). Please make sure it is correct or sign up below.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)",
  2009: "Please check your email address or sign up"
}, Fc = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, Lc = {
  2033: "Successfully created session.",
  2064: "Successfully updated session."
}, xc = {
  200: "Successfully created your first session.",
  201: "$t(responses.dashboardSession.200)"
}, jc = {
  2084: "Session access request was already in approved state",
  2088: "You've already requested access to this session.",
  email: {
    200: "People added"
  },
  domain: {
    200: "Group added"
  }
}, Hc = {
  200: "Great! We'll keep you up to date."
}, zc = {
  404: "$t(responses.default)",
  405: "The verification code is incorrect. Please double check.",
  500: "$t(responses.default)"
}, Vc = {
  500: "Sorry, something went wrong. Please try again.",
  avatar: {
    400: "Error saving avatar. Please try again."
  }
}, Gc = {
  default: "Sorry, something went wrong. Please try again.",
  timeout: $c,
  login: Mc,
  register: Fc,
  session: Lc,
  dashboardSession: xc,
  sessionAccess: jc,
  subscribe: Hc,
  verify: zc,
  user: Vc
}, qc = "Select meeting type", Qc = "All Hands", Bc = "Interview", Wc = "Planning Session", Yc = "Catchup/Coffee", Kc = "Knowledge Sharing", Jc = "Team Sync", Zc = "Client Meeting", Xc = "Workshop", eu = "Board Meeting", tu = "One - on - One", su = "Technical Review", nu = "Crisis Management", ru = {
  selectMeetingType: qc,
  all_hands: Qc,
  interview: Bc,
  planning_session: Wc,
  catchup_coffee: Yc,
  knowledge_sharing: Kc,
  team_sync: Jc,
  client_meeting: Zc,
  workshop: Xc,
  board_meeting: eu,
  one_on_one: tu,
  technical_review: su,
  crisis_management: nu
}, ou = `Here are the translations into Italian:

Agree - D'accordo`, au = "Celebrate - Festeggia", iu = "Completed - Completato", cu = "Disagree - Non d'accordo", uu = "Funny - Divertente", lu = "Hi - Ciao", du = "Love - Amore", mu = 'Wow - Wow (Note: "Wow" is often used in Italian as an exclamation of surprise or amazement, much like in English)', pu = {
  agree: ou,
  celebrate: au,
  completed: iu,
  disagree: cu,
  funny: uu,
  hi: lu,
  love: du,
  wow: mu
}, fu = {
  "logged-ticket-private": "{{name}} ha registrato questo",
  view: "Visualizza",
  "view-ticket": "Visualizza ticket",
  meeting: "Incontro",
  "shared-private": "{{name}} ha condiviso questo",
  "logged-ticket-public": "{{name}} ha registrato questo",
  "shared-public": "{{name}} ha registrato questo",
  "crated-meeting-public": "{{name}} ha condiviso un incontro",
  "crated-meeting-private": "{{name}} ha creato un incontro"
}, Su = {
  ticketing: "Emissione di biglietti",
  messaging: "Messaggistica"
}, gu = {
  link: fu,
  category: Su
}, hu = {
  guestSkippedSelf: "{{name}} si è saltato/a",
  hostSkippedGuest: "{{name}} è stato/a saltato/a",
  messageCode: {
    0: "⭐️ <span/> Stai facendo <em>benissimo!</em>",
    1: "👍 <span/> Ti <em>sentiamo</em> e vediamo",
    2: "☎️ <span/> Non possiamo <em>sentirti</em>",
    3: "🔴 <span/> Non possiamo <em>vederti</em>",
    4: "🔇 <span/> Per favore, <em>silenzia</em> il tuo microfono",
    5: "📢 <span/> Regola il tuo <em>audio</em>",
    6: "💡 <span/> Regola la tua <em>illuminazione</em>",
    7: "🔄 <span/> <em>Aggiorna</em> il tuo browser",
    8: "💪 <span/> Per favore, <em>rientra</em> nella coda",
    9: "⚠️ <span/>  Testa <em>camera e audio</em>",
    10: "⭐️ <span/> Sei stato/a <em>fantastico/a!</em>",
    11: "🎧 <span/> Prova a sistemare il tuo <em>audio</em>",
    12: "💡 <span/> Prova a sistemare la tua <em>illuminazione</em>",
    13: "🎯 <span/> <em>Invita persone</em> a unirsi",
    14: "⭐️ <span/> Sembri <em>fantastico/a!</em>",
    15: "👀 <span/> Controlla <em>il tuo telefono</em>",
    16: "🔴 <span/> Il tuo <em>video</em> ha problemi",
    17: "🎬 <span/> Sei il prossimo/a",
    18: "⏸ <span/> Ho <em>mess in pausa</em> la coda",
    19: "▶️ <span/> Devi <em>cliccare per riprendere</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "Impossibile inviare il messaggio",
  botsAddedToQueue: "Bot aggiunti alla coda"
}, yu = {
  session: hu
}, vu = "Azione scaduta. Si prega di controllare la propria connessione internet e riprovare.", Eu = {
  400: "Questo indirizzo email non è registrato su $t(_company). Si prega di assicurarsi che sia corretto o di registrarsi qui sotto.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, Tu = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, _u = {
  2033: "Sessione creata con successo.",
  2064: "Sessione aggiornata con successo."
}, Iu = {
  200: "Creata con successo la tua prima sessione.",
  201: "$t(responses.dashboardSession.200)"
}, bu = {
  2084: "La richiesta di accesso alla sessione era già in stato approvato",
  2088: "Hai già richiesto l'accesso a questa sessione.",
  email: {
    200: "Persone aggiunte"
  },
  domain: {
    200: "Gruppo aggiunto"
  }
}, Ru = {
  200: "Ottimo! Ti terremo aggiornato."
}, Au = {
  404: "$t(responses.default)",
  405: "Il codice di verifica non è corretto. Per favore, ricontrolla.",
  500: "$t(responses.default)"
}, Cu = {
  500: "Mi dispiace, si è verificato un errore. Per favore, riprova.",
  avatar: {
    400: "Errore nel salvataggio dell'avatar. Per favore, riprova."
  }
}, Ou = {
  default: "Mi dispiace, si è verificato un errore. Per favore, riprova.",
  timeout: vu,
  login: Eu,
  register: Tu,
  session: _u,
  dashboardSession: Iu,
  sessionAccess: bu,
  subscribe: Ru,
  verify: Au,
  user: Cu
}, Nu = "Einverstanden", wu = "Feiern", Uu = "Abgeschlossen", Pu = "Nicht einverstanden", Du = "Lustig", ku = "Hallo", $u = "Liebe", Mu = "Wow", Fu = {
  agree: Nu,
  celebrate: wu,
  completed: Uu,
  disagree: Pu,
  funny: Du,
  hi: ku,
  love: $u,
  wow: Mu
}, Lu = {
  "logged-ticket-private": "{{name}} hat dies protokolliert",
  view: "Ansehen",
  "view-ticket": "Ticket anzeigen",
  meeting: "Besprechung",
  "shared-private": "{{name}} hat dies geteilt",
  "logged-ticket-public": "{{name}} hat dies protokolliert",
  "shared-public": "{{name}} hat dies protokolliert",
  "crated-meeting-public": "{{name}} hat eine Besprechung geteilt",
  "crated-meeting-private": "{{name}} hat eine Besprechung erstellt"
}, xu = {
  ticketing: "Ticketing",
  messaging: "Nachrichtenversand"
}, ju = {
  link: Lu,
  category: xu
}, Hu = {
  guestSkippedSelf: "{{name}} hat sich selbst ausgelassen",
  hostSkippedGuest: "{{name}} wurde übersprungen",
  messageCode: {
    0: "⭐️ <span/> Du machst das <em>großartig!</em>",
    1: "👍 <span/> Wir <em>hören</em> & sehen dich",
    2: "☎️ <span/> Können dich nicht <em>hören</em>",
    3: "🔴 <span/> Können dich nicht <em>sehen</em>",
    4: "🔇 <span/> Bitte schalte dein Mikrofon <em>stumm</em>",
    5: "📢 <span/> Behebe dein <em>Audio</em>-Problem",
    6: "💡 <span/> Korrigiere deine <em>Beleuchtung</em>",
    7: "🔄 <span/> Aktualisiere deinen Browser <em>neu</em>",
    8: "💪 <span/> Bitte trete der Warteschlange <em>erneut bei</em>",
    9: "⚠️ <span/> Teste <em>Kamera & Ton</em>",
    10: "⭐️ <span/> Du warst <em>großartig!</em>",
    11: "🎧 <span/> Versuche, dein <em>Audio</em>-Problem zu beheben",
    12: "💡 <span/> Versuche, deine <em>Beleuchtung</em> zu verbessern",
    13: "🎯 <span/> Bitte <em>leute</em>, der Sitzung beizutreten",
    14: "⭐️ <span/> Sieht <em>gut aus!</em>",
    15: "👀 <span/> Überprüfe <em>dein Handy</em>",
    16: "🔴 <span/> Dein <em>Video</em> funktioniert nicht richtig",
    17: "🎬 <span/> Du bist als Nächster dran",
    18: "⏸ <span/> Ich habe die Warteschlange <em>angehalten</em>",
    19: "▶️ <span/> Du musst <em>weiter</em> klicken",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "Nachricht konnte nicht gesendet werden",
  botsAddedToQueue: "Bots wurden zur Warteschlange hinzugefügt"
}, zu = {
  session: Hu
}, Vu = "Aktion abgelaufen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.", Gu = {
  400: "Diese E-Mail-Adresse ist auf $t(_company) nicht registriert. Bitte stellen Sie sicher, dass sie korrekt ist, oder melden Sie sich unten an.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, qu = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, Qu = {
  2033: "Sitzung erfolgreich erstellt.",
  2064: "Sitzung erfolgreich aktualisiert."
}, Bu = {
  200: "Ihre erste Sitzung wurde erfolgreich erstellt.",
  201: "$t(responses.dashboardSession.200)"
}, Wu = {
  2084: "Die Anfrage auf Zugang zur Sitzung war bereits im genehmigten Zustand",
  2088: "Sie haben bereits Zugang zu dieser Sitzung beantragt.",
  email: {
    200: "Personen hinzugefügt"
  },
  domain: {
    200: "Gruppe hinzugefügt"
  }
}, Yu = {
  200: "Großartig! Wir halten Sie auf dem Laufenden."
}, Ku = {
  404: "$t(responses.default)",
  405: "Der Verifizierungscode ist falsch. Bitte überprüfen Sie noch einmal.",
  500: "$t(responses.default)"
}, Ju = {
  500: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  avatar: {
    400: "Fehler beim Speichern des Avatars. Bitte versuchen Sie es erneut."
  }
}, Zu = {
  default: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  timeout: Vu,
  login: Gu,
  register: qu,
  session: Qu,
  dashboardSession: Bu,
  sessionAccess: Wu,
  subscribe: Yu,
  verify: Ku,
  user: Ju
}, Xu = "A continuación, la traducción solicitada de los textos al español:", el = "Acuerdo", tl = "Celebrar", sl = "Completado", nl = "Desacuerdo", rl = "Divertido", ol = "Hola", al = "Amor", il = {
  agree: Xu,
  celebrate: el,
  completed: tl,
  disagree: sl,
  funny: nl,
  hi: rl,
  love: ol,
  wow: al
}, cl = {
  "logged-ticket-private": "{{name}} registró esto",
  view: "Ver",
  "view-ticket": "Ver ticket",
  meeting: "Reunión",
  "shared-private": "{{name}} compartió esto",
  "logged-ticket-public": "{{name}} registró esto",
  "shared-public": "{{name}} registró esto",
  "crated-meeting-public": "{{name}} ha compartido una reunión",
  "crated-meeting-private": "{{name}} creó una reunión"
}, ul = {
  ticketing: "Gestión de tickets",
  messaging: "Mensajería"
}, ll = {
  link: cl,
  category: ul
}, dl = {
  guestSkippedSelf: "{{name}} se ha saltado a sí mismo",
  hostSkippedGuest: "{{name}} fue saltado",
  messageCode: {
    0: "⭐️ <span/> Estás haciendo un <em>gran trabajo</em>!",
    1: "👍 <span/> Te <em>escuchamos</em> y te vemos",
    2: "☎️ <span/> No podemos <em>oirte</em>",
    3: "🔴 <span/> No podemos <em>verte</em>",
    4: "🔇 <span/> Por favor, <em>silencia</em> tu micrófono",
    5: "📢 <span/> Arregla tu <em>audio</em>",
    6: "💡 <span/> Arregla tu <em>iluminación</em>",
    7: "🔄 <span/> <em>Actualiza</em> tu navegador",
    8: "💪 <span/> Por favor, <em>vuelve a</em> la cola",
    9: "⚠️ <span/>  Prueba la <em>cámara y el sonido</em>",
    10: "⭐️ <span/> ¡Estuviste <em>genial</em>!",
    11: "🎧 <span/> Intenta arreglar tu <em>audio</em>",
    12: "💡 <span/> Intenta arreglar tu <em>iluminación</em>",
    13: "🎯 <span/> <em>Pide a la gente</em> que se una",
    14: "⭐️ <span/> Te ves <em>genial</em>",
    15: "👀 <span/> Revisa <em>tu teléfono</em>",
    16: "🔴 <span/> <em>Tu vídeo</em> tiene un problema",
    17: "🎬 <span/> Tú sigues",
    18: "⏸ <span/> <em>He pausado</em> la cola",
    19: "▶️ <span/> Necesitas <em>hacer clic en reanudar</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "No se pudo enviar el mensaje",
  botsAddedToQueue: "Se agregaron bots a la cola"
}, ml = {
  session: dl
}, pl = "Acción agotada por tiempo. Por favor, verifica tu conexión a internet e intenta de nuevo.", fl = {
  400: "Esta dirección de correo electrónico no está registrada en $t(_company). Por favor, asegúrate de que es correcta o regístrate a continuación.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, Sl = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, gl = {
  2033: "Sesión creada exitosamente.",
  2064: "Sesión actualizada exitosamente."
}, hl = {
  200: "Has creado tu primera sesión exitosamente.",
  201: "$t(responses.dashboardSession.200)"
}, yl = {
  2084: "La solicitud de acceso a la sesión ya estaba en estado aprobado",
  2088: "Ya has solicitado acceso a esta sesión.",
  email: {
    200: "Personas añadidas"
  },
  domain: {
    200: "Grupo añadido"
  }
}, vl = {
  200: "¡Genial! Te mantendremos informado."
}, El = {
  404: "$t(responses.default)",
  405: "El código de verificación es incorrecto. Por favor, comprueba de nuevo.",
  500: "$t(responses.default)"
}, Tl = {
  500: "Lo sentimos, algo salió mal. Por favor, intenta de nuevo.",
  avatar: {
    400: "Error al guardar el avatar. Por favor, intenta de nuevo."
  }
}, _l = {
  default: "Lo sentimos, algo salió mal. Por favor, intenta de nuevo.",
  timeout: pl,
  login: fl,
  register: Sl,
  session: gl,
  dashboardSession: hl,
  sessionAccess: yl,
  subscribe: vl,
  verify: El,
  user: Tl
}, Il = "Zgadzam się", bl = "Świętować", Rl = "Ukończony", Al = "Nie zgadzam się", Cl = "Śmieszny", Ol = "Cześć", Nl = "Kochać", wl = "Wow", Ul = {
  agree: Il,
  celebrate: bl,
  completed: Rl,
  disagree: Al,
  funny: Cl,
  hi: Ol,
  love: Nl,
  wow: wl
}, Pl = {
  "logged-ticket-private": "{{name}} zalogował to",
  view: "Widok",
  "view-ticket": "Zobacz zgłoszenie",
  meeting: "Spotkanie",
  "shared-private": "{{name}} udostępnił to",
  "logged-ticket-public": "{{name}} zalogował to",
  "shared-public": "{{name}} zalogował to",
  "crated-meeting-public": "{{name}} udostępnił spotkanie",
  "crated-meeting-private": "{{name}} utworzył spotkanie"
}, Dl = {
  ticketing: "System zgłoszeń",
  messaging: "Wiadomości"
}, kl = {
  link: Pl,
  category: Dl
}, $l = {
  guestSkippedSelf: "{{name}} pominął sam siebie",
  hostSkippedGuest: "{{name}} został pominięty",
  messageCode: {
    0: "⭐️ <span/> Robisz to <em>świetnie!</em>",
    1: "👍 <span/> <em>Słyszymy</em> Cię i widzimy",
    2: "☎️ <span/> Nie <em>słyszymy</em> Cię",
    3: "🔴 <span/> Nie <em>widzimy</em> Ciebie",
    4: "🔇 <span/> Proszę, <em>wycisz</em> się",
    5: "📢 <span/> Napraw swoje <em>dźwięki</em>",
    6: "💡 <span/> Napraw swoje <em>oświetlenie</em>",
    7: "🔄 <span/> Odśwież swoją <em>przeglądarkę</em>",
    8: "💪 <span/> Proszę, <em>dołącz</em> ponownie do kolejki",
    9: "⚠️ <span/> Przetestuj <em>kamerę i dźwięk</em>",
    10: "⭐️ <span/> Byłeś <em>świetny!</em>",
    11: "🎧 <span/> Spróbuj naprawić swój <em>dźwięk</em>",
    12: "💡 <span/> Spróbuj naprawić swoje <em>oświetlenie</em>",
    13: "🎯 <span/> <em>Zaproś ludzi</em> do dołączenia",
    14: "⭐️ <span/> Wyglądasz <em>świetnie!</em>",
    15: "👀 <span/> Sprawdź <em>swoją komórkę</em>",
    16: "🔴 <span/> <em>Twoje wideo</em> ma usterki",
    17: "🎬 <span/> Jesteś następny",
    18: "⏸ <span/> <em>Zatrzymałem</em> kolejkę",
    19: "▶️ <span/> Musisz <em>kliknąć wznowienie</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "Nie udało się wysłać wiadomości",
  botsAddedToQueue: "Boty zostały dodane do kolejki"
}, Ml = {
  session: $l
}, Fl = "Czas działania minął. Proszę sprawdzić swoje połączenie internetowe i spróbować ponownie.", Ll = {
  400: "Ten adres e-mail nie jest zarejestrowany w $t(_company). Upewnij się, że jest poprawny lub zarejestruj się poniżej.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, xl = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, jl = {
  2033: "Pomyślnie utworzono sesję.",
  2064: "Pomyślnie zaktualizowano sesję."
}, Hl = {
  200: "Pomyślnie utworzono Twoją pierwszą sesję.",
  201: "$t(responses.dashboardSession.200)"
}, zl = {
  2084: "Prośba o dostęp do sesji została już zatwierdzona",
  2088: "Już wysłałeś prośbę o dostęp do tej sesji.",
  email: {
    200: "Osoby dodane"
  },
  domain: {
    200: "Grupa dodana"
  }
}, Vl = {
  200: "Świetnie! Będziemy Cię na bieżąco informować."
}, Gl = {
  404: "$t(responses.default)",
  405: "Kod weryfikacyjny jest nieprawidłowy. Proszę sprawdzić ponownie.",
  500: "$t(responses.default)"
}, ql = {
  500: "Przepraszamy, coś poszło nie tak. Proszę spróbować ponownie.",
  avatar: {
    400: "Błąd zapisu awatara. Proszę spróbować ponownie."
  }
}, Ql = {
  default: "Przepraszamy, coś poszło nie tak. Proszę spróbować ponownie.",
  timeout: Fl,
  login: Ll,
  register: xl,
  session: jl,
  dashboardSession: Hl,
  sessionAccess: zl,
  subscribe: Vl,
  verify: Gl,
  user: ql
}, Bl = "동의", Wl = "축하하다", Yl = "완료됨", Kl = "동의하지 않음", Jl = "웃긴", Zl = "안녕", Xl = "사랑", ed = "와우", td = {
  agree: Bl,
  celebrate: Wl,
  completed: Yl,
  disagree: Kl,
  funny: Jl,
  hi: Zl,
  love: Xl,
  wow: ed
}, sd = {
  "logged-ticket-private": "{{name}}님이 이것을 기록했습니다",
  view: "보기",
  "view-ticket": "티켓 보기",
  meeting: "미팅",
  "shared-private": "{{name}}님이 이것을 공유했습니다",
  "logged-ticket-public": "{{name}}님이 이것을 기록했습니다",
  "shared-public": "{{name}}님이 이것을 기록했습니다",
  "crated-meeting-public": "{{name}}님이 미팅을 공유했습니다",
  "crated-meeting-private": "{{name}}님이 미팅을 만들었습니다"
}, nd = {
  ticketing: "티켓 발급",
  messaging: "메시징"
}, rd = {
  link: sd,
  category: nd
}, od = {
  guestSkippedSelf: "{{name}} 님이 자신을 건너뛰었습니다",
  hostSkippedGuest: "{{name}} 님이 건너뛰어졌습니다",
  messageCode: {
    0: "⭐️ <span/> 잘하고 있어요!<em>대단해!</em>",
    1: "👍 <span/> 여러분의 목소리를 <em>듣고</em> 보고 있습니다",
    2: "☎️ <span/> 당신의 목소리를 <em>들을 수</em> 없습니다",
    3: "🔴 <span/> 당신을 <em>볼 수</em> 없습니다",
    4: "🔇 <span/> 마이크를 <em>음소거</em>해 주세요",
    5: "📢 <span/> 오디오를 <em>고치세요</em>",
    6: "💡 <span/> 조명을 <em>고치세요</em>",
    7: "🔄 <span/> 브라우저를 <em>새로고침</em>하세요",
    8: "💪 <span/> 다시 대기열에 <em>들어가</em> 주세요",
    9: "⚠️ <span/>  카메라와 소리를 <em>테스트하세요</em>",
    10: "⭐️ <span/> 정말 <em>잘했어요!</em>",
    11: "🎧 <span/> 오디오를 고쳐 <em>보세요</em>",
    12: "💡 <span/> 조명을 고쳐 <em>보세요</em>",
    13: "🎯 <span/> 사람들에게 참여할 것을 <em>요청하세요</em>",
    14: "⭐️ <span/> 멋져 <em>보여요!</em>",
    15: "👀 <span/> 휴대폰을 <em>확인해보세요</em>",
    16: "🔴 <span/> <em>비디오</em>에 문제가 있습니다",
    17: "🎬 <span/> 곧 당신 차례입니다",
    18: "⏸ <span/> 대기열을 <em>일시 중지했습니다</em>",
    19: "▶️ <span/> 다시 시작하려면 <em>클릭하세요</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "메시지 전송 실패",
  botsAddedToQueue: "대기열에 봇이 추가되었습니다"
}, ad = {
  session: od
}, id = "작업 시간이 초과되었습니다. 인터넷 연결을 확인하고 다시 시도해 주세요.", cd = {
  400: "이 이메일 주소는 $t(_company)에 등록되어 있지 않습니다. 올바른지 확인하거나 아래에서 가입해 주세요.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, ud = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, ld = {
  2033: "세션을 성공적으로 생성했습니다.",
  2064: "세션을 성공적으로 업데이트했습니다."
}, dd = {
  200: "첫 세션을 성공적으로 생성했습니다.",
  201: "$t(responses.dashboardSession.200)"
}, md = {
  2084: "세션 접근 요청이 이미 승인된 상태입니다",
  2088: "이미 이 세션에 접근을 요청했습니다.",
  email: {
    200: "사람들이 추가되었습니다"
  },
  domain: {
    200: "그룹이 추가되었습니다"
  }
}, pd = {
  200: "좋습니다! 최신 정보를 알려드리겠습니다."
}, fd = {
  404: "$t(responses.default)",
  405: "인증 코드가 정확하지 않습니다. 다시 확인해 주세요.",
  500: "$t(responses.default)"
}, Sd = {
  500: "죄송합니다, 문제가 발생했습니다. 다시 시도해 주세요.",
  avatar: {
    400: "아바타 저장에 오류가 발생했습니다. 다시 시도해 주세요."
  }
}, gd = {
  default: "죄송합니다, 문제가 발생했습니다. 다시 시도해 주세요.",
  timeout: id,
  login: cd,
  register: ud,
  session: ld,
  dashboardSession: dd,
  sessionAccess: md,
  subscribe: pd,
  verify: fd,
  user: Sd
}, hd = "Concordo", yd = "Celebre", vd = "Concluído", Ed = "Discordo", Td = "Engraçado", _d = "Oi", Id = "Amor", bd = "Uau", Rd = {
  agree: hd,
  celebrate: yd,
  completed: vd,
  disagree: Ed,
  funny: Td,
  hi: _d,
  love: Id,
  wow: bd
}, Ad = {
  "logged-ticket-private": "{{name}} registrou isto",
  view: "Visualizar",
  "view-ticket": "Ver bilhete/ingresso",
  meeting: "Reunião",
  "shared-private": "{{name}} compartilhou isto",
  "logged-ticket-public": "{{name}} registrou isto",
  "shared-public": "{{name}} registrou isto",
  "crated-meeting-public": "{{name}} compartilhou uma reunião",
  "crated-meeting-private": "{{name}} criou uma reunião"
}, Cd = {
  ticketing: "Emissão de bilhetes/ingressos",
  messaging: "Mensagens"
}, Od = {
  link: Ad,
  category: Cd
}, Nd = {
  guestSkippedSelf: "{{name}} pulou a sua vez",
  hostSkippedGuest: "{{name}} foi pulado",
  messageCode: {
    0: "⭐️ <span/> Você está indo <em>ótimo!</em>",
    1: "👍 <span/> Nós <em>ouvimos</em> e vemos você",
    2: "☎️ <span/> Não conseguimos <em>ouvir</em> você",
    3: "🔴 <span/> Não conseguimos <em>ver</em> você",
    4: "🔇 <span/> Por favor, <em>silencie-se</em>",
    5: "📢 <span/> Arrume o seu <em>áudio</em>",
    6: "💡 <span/> Ajuste a sua <em>iluminação</em>",
    7: "🔄 <span/> <em>Atualize</em> o seu navegador",
    8: "💪 <span/> Por favor, <em>volte</em> para a fila",
    9: "⚠️ <span/> Teste <em>câmera e som</em>",
    10: "⭐️ <span/> Você foi <em>ótimo!</em>",
    11: "🎧 <span/> Tente arrumar o seu <em>áudio</em>",
    12: "💡 <span/> Tente arrumar a sua <em>iluminação</em>",
    13: "🎯 <span/> <em>Peça para as pessoas</em> entrarem",
    14: "⭐️ <span/> Está <em>ótimo!</em>",
    15: "👀 <span/> Verifique <em>o seu celular</em>",
    16: "🔴 <span/> O seu <em>vídeo</em> está com defeito",
    17: "🎬 <span/> Você é o próximo",
    18: "⏸ <span/> <em>Eu pausei</em> a fila",
    19: "▶️ <span/> Você precisa <em>clicar em continuar</em>",
    100: "👍",
    101: "👎",
    102: "❤️",
    103: "👏️"
  },
  failedToSendMessage: "Falha ao enviar mensagem",
  botsAddedToQueue: "Bots foram adicionados à fila"
}, wd = {
  session: Nd
}, Ud = "Ação esgotou o tempo. Por favor, verifique sua conexão com a internet e tente novamente.", Pd = {
  400: "Este endereço de email não está registrado no $t(_company). Por favor, verifique se está correto ou inscreva-se abaixo.",
  404: "$t(responses.login.400)",
  500: "$t(responses.default)"
}, Dd = {
  400: "$t(responses.default)",
  500: "$t(responses.default)"
}, kd = {
  2033: "Sessão criada com sucesso.",
  2064: "Sessão atualizada com sucesso."
}, $d = {
  200: "Sua primeira sessão foi criada com sucesso.",
  201: "$t(responses.dashboardSession.200)"
}, Md = {
  2084: "Solicitação de acesso à sessão já estava em estado aprovado",
  2088: "Você já solicitou acesso a esta sessão.",
  email: {
    200: "Pessoas adicionadas"
  },
  domain: {
    200: "Grupo adicionado"
  }
}, Fd = {
  200: "Ótimo! Vamos mantê-lo(a) atualizado(a)."
}, Ld = {
  404: "$t(responses.default)",
  405: "O código de verificação está incorreto. Por favor, verifique novamente.",
  500: "$t(responses.default)"
}, xd = {
  500: "Desculpe, algo deu errado. Por favor, tente novamente.",
  avatar: {
    400: "Erro ao salvar avatar. Por favor, tente novamente."
  }
}, jd = {
  default: "Desculpe, algo deu errado. Por favor, tente novamente.",
  timeout: Ud,
  login: Pd,
  register: Dd,
  session: kd,
  dashboardSession: $d,
  sessionAccess: Md,
  subscribe: Fd,
  verify: Ld,
  user: xd
}, GS = {
  en: {
    responses: Gc,
    notifications: kc,
    emojiReactions: Sc,
    integrations: Pc,
    userMeetingTypes: ru
  },
  it: {
    responses: Ou,
    notifications: yu,
    emojiReactions: pu,
    integrations: gu
  },
  de: {
    responses: Zu,
    notifications: zu,
    emojiReactions: Fu,
    integrations: ju
  },
  es: {
    responses: _l,
    notifications: ml,
    emojiReactions: il,
    integrations: ll
  },
  pl: {
    responses: Ql,
    notifications: Ml,
    emojiReactions: Ul,
    integrations: kl
  },
  ko: {
    responses: gd,
    notifications: ad,
    emojiReactions: td,
    integrations: rd
  },
  pt: {
    responses: jd,
    notifications: wd,
    emojiReactions: Rd,
    integrations: Od
  }
};
export {
  Oo as ACTION,
  cn as ACTION_CLEAR,
  on as ACTION_FAILURE,
  an as ACTION_REMOVE,
  nn as ACTION_REQUEST,
  rn as ACTION_SUCCESS,
  cp as ACTIVE_GUESTS,
  am as ADD_USER_ROLE,
  En as AUTHENTICATED,
  Re as ActionStatus,
  ur as CANCEL_INTERRUPT_SESSION,
  di as CHECK_INTERRUPT_SESSION,
  pi as CHECK_SESSION_ACCESS,
  fr as CLEAR_INDIVIDUAL_EMOJI_REACTIONS,
  Kn as CLEAR_SESSION,
  ar as CLOSE_SESSION_MODAL,
  Gm as CURRENT_USER_CHIMING_IN_EVENT,
  qm as CURRENT_USER_CHIMING_IN_STOPPED_EVENT,
  nt as CameraTrackQualityRegulator,
  Bn as END_SESSION,
  Co as GENERIC_ACTION,
  sn as GENERIC_ACTION_FAILURE,
  en as GENERIC_ACTION_REQUEST,
  tn as GENERIC_ACTION_SUCCESS,
  xe as GET_CURRENT_USER,
  ym as GET_CURRENT_USER_FAILURE,
  gm as GET_CURRENT_USER_REQUEST,
  hm as GET_CURRENT_USER_SUCCESS,
  tc as GET_USER,
  gr as GRANT_CONSENT_TO_BROADCAST,
  er as GUEST_IS_READY_STREAM,
  ip as GUEST_ON_AIR,
  ni as GUEST_READY,
  ci as GUEST_TO_HOST_CONNECT,
  ri as GUEST_UP_NEXT,
  nr as HOST_ENTERED_SESSION,
  ui as HOST_TO_GUEST_CONNECT,
  Zn as INIT_SCREEN_SHARING,
  lr as INTERRUPT_SESSION,
  ei as JOIN_SESSION,
  mn as LOGOUT,
  pa as LandscapeVideoPresets,
  jn as NAVIGATE_TO,
  up as ON_AIR_SOUND_EFFECT_PLAYED,
  ma as PortraitVideoPresets,
  vn as REFRESH_SUBSCRIPTION_PLAN,
  ai as REMOVE_FROM_QUEUE,
  ii as REMOVE_FROM_QUEUE_SUCCESS,
  im as REMOVE_USER_ROLE,
  mi as REQUEST_CHIME_IN,
  rt as REQUEST_OTP,
  lm as REQUEST_OTP_FAILURE,
  um as REQUEST_OTP_SUCCESS,
  li as REQUEST_SESSION_FOCUS,
  Uo as REQUEST_USER_SESSION_INFO,
  Tn as REQUEST_USER_SESSION_INFO_RESPONSE,
  Po as REQUEST_USER_SESSION_INFO_RESPONSE_ERROR,
  lp as RESET_ON_AIR_SOUND_EFFECT_PLAYED,
  hr as REVOKE_CONSENT_TO_BROADCAST,
  si as SESSION_ACCESS_GRANTED,
  pn as SETUP_AUTH,
  Za as SETUP_CURRENT_SESSION,
  Xa as SETUP_CURRENT_SESSION_RESPONSE,
  Gn as SET_ACTIVE_SESSION,
  gn as SET_AUTH_STATE,
  qn as SET_BOTH_SESSIONS,
  dr as SET_COUNTDOWN,
  Vn as SET_CURRENT_SESSION,
  Qn as SET_CURRENT_SESSION_STATE,
  fn as SET_CURRENT_USER,
  cm as SET_CURRENT_USER_SUBSCRIPTION_PLAN,
  cr as SET_FEATURED_SESSION,
  ir as SET_FEATURED_SESSIONS,
  pr as SET_INDIVIDUAL_EMOJI_REACTIONS,
  Or as SET_MODAL,
  yr as SET_OFF_THE_RECORD_STATUS,
  sr as SET_QUEUE,
  Yn as SET_SESSION,
  or as SET_SESSION_MODAL,
  rr as SET_SESSION_QUEUE_STATUS,
  mr as SET_SESSION_ROLE_PRESENCE,
  Wn as SET_SESSION_STATUS,
  Er as SET_STREAM_FALLBACK,
  yn as SET_SUBSCRIPTION_PLAN,
  Mr as SET_USER,
  oi as SHOW_SURVEY,
  Jn as START_SCREEN_SHARING,
  ti as START_SESSION,
  Xn as STOP_SCREEN_SHARING,
  Di as SessionModalType,
  vS as SessionStateKey,
  Xm as TargetScreenShareStreamPreset,
  P as TargetVideoPresets,
  wo as UN_AUTHENTICATED,
  hn as UPDATE_AUTH_STATE,
  Sr as UPDATE_CHIMED_IN_USERS,
  Sn as UPDATE_CURRENT_USER,
  tr as UPDATE_SESSION,
  vr as UPDATE_USER_MEDIA,
  No as UPDATE_USER_ROLES,
  zn as UPDATE_VIEW_COUNT,
  DS as UserStateKey,
  ot as VERIFY_AUTH_PROVIDER,
  Sm as VERIFY_AUTH_PROVIDER_FAILURE,
  fm as VERIFY_AUTH_PROVIDER_SUCCESS,
  Ee as VERIFY_OTP,
  pm as VERIFY_OTP_FAILURE,
  dm as VERIFY_OTP_REQUEST,
  mm as VERIFY_OTP_SUCCESS,
  Ym as actionClear,
  ke as actionFailure,
  dn as actionFailureType,
  ua as actionRemove,
  $t as actionRequest,
  un as actionRequestType,
  ct as actionSuccess,
  ln as actionSuccessType,
  Mn as actionsMiddleware,
  Km as actionsMiddlewares,
  ca as activeOptions,
  Ja as addFullName,
  Hn as addFullNames,
  ap as anonymize,
  op as areEqual,
  jp as authSaga,
  De as authService,
  Dt as authenticated,
  Io as buildSocialProfileLink,
  om as buildSocialUrls,
  J as cacheKeys,
  Kp as cancelInterruptSession,
  Yp as checkForInterruptSession,
  Mf as checkSessionAccess,
  Df as clearIndividualEmojiReactions,
  lf as clearSession,
  ff as closeSessionModal,
  zS as commonMiddlewares,
  GS as commonTranslations,
  Ps as comparePreset,
  K as config,
  sm as denormalizeState,
  Vm as emojiReactionsOptions,
  kn as emptyCacheKey,
  Qm as emptyFn,
  Bp as endScreenSharing,
  Jp as endSession,
  Hp as featureFlagsService,
  OS as findPrice,
  Ka as fullName,
  np as fullName2,
  Zm as getActionData,
  la as getActions,
  se as getActiveOptions,
  es as getCurrentMeetingType,
  vm as getCurrentUser,
  $r as getFeature,
  rp as getFirstNameAndInitial,
  ne as getInactiveOptions,
  Lm as getInfinityRequestData,
  To as getMeetingType,
  ec as getPrice,
  fi as getPrimaryHost,
  bo as getProfileUrl,
  Fm as getQueryRequestData,
  dt as getRequestData,
  pp as getSessionEndedAt,
  br as getSessionPresenceByRole,
  Rr as getSessionPresenceByRoleList,
  dp as getSessionPrimaryHost,
  mp as getSessionStartedAt,
  Tr as getSessionStateChangeAt,
  CS as getTrialDaysLeft,
  US as getUser,
  kf as grantConsentToBroadcast,
  Tf as guestReadyToStream,
  If as guestToHost,
  nm as hasGoogleCalendarIntegration,
  yf as hostEnteredSession,
  bf as hostToGuest,
  $n as inactiveOptions,
  Xd as initConfig,
  qp as initScreenSharing,
  tm as integrations,
  Wp as interruptSession,
  Si as isActiveStatus,
  AS as isFeatureDisabled,
  RS as isFeatureEnabled,
  bS as isFreeOrFreeTrialPlan,
  Ji as isFreePlan,
  Xi as isFreeTrialPlan,
  IS as isFreeType,
  rm as isPartyModeMeeting,
  NS as isPaymentFailing,
  Ki as isPlanCanceling,
  em as isRequestErrorCode,
  Eo as isSessionActive,
  fp as isSessionPrimaryHost,
  Zi as isTrialPlan,
  Sf as joinSession,
  Do as logout,
  da as makeSelectActionByName,
  PS as makeSelectUserById,
  Ni as modalInitialState,
  wi as modalReducer,
  us as navigateTo,
  Ui as navigationInitialState,
  Pi as navigationReducer,
  Ef as nextGuestReady,
  tp as nextPreset,
  vo as normalizeState,
  vf as nowGuestReady,
  TS as planFeatures,
  ES as planOrder,
  ep as presetWithName,
  sp as previousPreset,
  Wa as reactQueryCacheService,
  VS as reducers,
  Am as refreshSubscriptionPlan,
  tf as removeFromQueue,
  sf as removeFromQueueSuccess,
  Uf as requestChimeIn,
  ko as requestOTP,
  ki as requestSessionFocus,
  _m as requestUserSessionInfo,
  Im as requestUserSessionInfoResponse,
  bm as requestUserSessionInfoResponseError,
  $f as revokeConsentToBroadcast,
  dS as selectActiveHasSessionMaxSpeakers,
  Dr as selectActiveHostsCount,
  Qi as selectActivePresenceByRole,
  Pr as selectActivePresenceByRoleList,
  Bi as selectActivePresenceHostsOnlyByRoleList,
  lS as selectActivePresenceViewersOnlyByRoleList,
  ie as selectActiveSession,
  Ye as selectActiveSessionChimedInUsers,
  Ke as selectActiveSessionData,
  Nr as selectActiveSessionDataLiveScreenShareDetails,
  Lt as selectActiveSessionHosts,
  ms as selectActiveSessionId,
  Hf as selectActiveSessionInfo,
  xi as selectActiveSessionMeetingType,
  Wi as selectActiveSessionOrganizer,
  $i as selectActiveSessionProducers,
  jf as selectActiveSessionRecurrenceId,
  Mi as selectActiveSessionSettings,
  qf as selectActiveSessionShareUrl,
  Gf as selectActiveSessionStatus,
  Vf as selectActiveSessionSubscriptionPlan,
  zf as selectActiveSessionTimestamps,
  iS as selectActiveSessionUsers,
  Gi as selectActiveUsers,
  Mm as selectAgentId,
  _r as selectAllSessions,
  $m as selectAuthAccessToken,
  W as selectAuthState,
  ra as selectAuthStatus,
  km as selectAuthToken,
  os as selectAuthUserId,
  oS as selectChimedInUsersCount,
  Vi as selectConsentToBroadcast,
  ee as selectCurrentSession,
  ls as selectCurrentSessionId,
  Rp as selectCurrentSessionInfo,
  bp as selectCurrentSessionRecurrenceId,
  Ip as selectCurrentSessionState,
  Cp as selectCurrentSessionSubscriptionPlan,
  We as selectCurrentUser,
  Cm as selectCurrentUserEmail,
  Dm as selectCurrentUserEmailSetting,
  Om as selectCurrentUserFullName,
  me as selectCurrentUserId,
  wm as selectCurrentUserPushSetting,
  zi as selectCurrentUserQueueIndex,
  aa as selectCurrentUserRoles,
  Pm as selectCurrentUserScreenShareIds,
  Pn as selectCurrentUserSettings,
  oa as selectCurrentUserStreamId,
  Nm as selectCurrentUserSubscriptionPlan,
  Ep as selectFeaturedSessionById,
  yp as selectFeaturedSessions,
  vp as selectFeaturedSessionsIds,
  aS as selectHasChimedInUsers,
  xp as selectHasSessionMaxSpeakers,
  Jf as selectHasUsers,
  Bf as selectHasViewers,
  Ei as selectHostsCount,
  gi as selectInterruptedSessions,
  ps as selectIsActiveSessionHost,
  Yf as selectIsActiveSessionOrganizer,
  fS as selectIsActiveSessionOrganizerPresent,
  hS as selectIsAudioEnabled,
  yS as selectIsAudioOnly,
  na as selectIsAuthenticated,
  Dp as selectIsCurrentSessionOrganizer,
  Wf as selectIsCurrentStreamLive,
  nS as selectIsCurrentUserActive,
  Kf as selectIsCurrentUserChimedIn,
  Zf as selectIsCurrentUserInQueue,
  ji as selectIsCurrentUserLive,
  tS as selectIsCurrentUserSharingScreen,
  yi as selectIsSessionHost,
  qi as selectIsSessionInterrupted,
  Mp as selectIsSessionOrganizer,
  sS as selectIsSomeoneScreenSharing,
  gS as selectIsVideoEnabled,
  Vp as selectModal,
  Gp as selectNavigation,
  rS as selectNextUser,
  SS as selectOffTheRecordStatus,
  vi as selectPresenceByRole,
  Ar as selectPresenceByRoleList,
  kp as selectPresenceHostsOnlyByRoleList,
  $p as selectPresenceViewersOnlyByRoleList,
  ft as selectQueue,
  Fi as selectQueueHasNow,
  Qf as selectQueueHasUsers,
  Li as selectQueueNext,
  Oe as selectQueueNow,
  St as selectQueueStatus,
  xt as selectQueueUsers,
  uS as selectReactionById,
  cS as selectReactions,
  Ur as selectScreenSharedUsers,
  gp as selectSessionById,
  Pp as selectSessionData,
  hp as selectSessionExists,
  hi as selectSessionHosts,
  Up as selectSessionInfo,
  Lp as selectSessionMeetingType,
  Tp as selectSessionModal,
  Fp as selectSessionOrganizer,
  Op as selectSessionSettings,
  Ap as selectSessionShareUrl,
  G as selectSessionState,
  wp as selectSessionStatus,
  Np as selectSessionTimestamps,
  Ir as selectSessionsPresence,
  Xf as selectShouldBroadcast,
  eS as selectShouldReceive,
  Hi as selectUserCount,
  _p as selectUserPresenceStatus,
  nc as selectUserState,
  Um as selectUserStreamIds,
  rc as selectUsers,
  wr as selectViewerCount,
  mS as selectViewersOnlyCount,
  pS as selectVirtualAgentsInQueue,
  qa as session,
  cf as sessionAccessGranted,
  re as sessionInitialState,
  Qa as sessionViewerAccess,
  Sp as sessionsReducer,
  af as setActiveSession,
  Qe as setAuthState,
  of as setBothSessions,
  Cf as setCountdown,
  rf as setCurrentSession,
  Nf as setCurrentSessionState,
  Em as setCurrentUser,
  Af as setFeaturedSession,
  Rf as setFeaturedSessions,
  wf as setIndividualEmojiReactions,
  zp as setModal,
  Lf as setOffTheRecordStatus,
  hf as setQueue,
  uf as setSession,
  pf as setSessionModal,
  Xp as setSessionQueueStatus,
  Of as setSessionRolePresence,
  Zp as setSessionStatus,
  xf as setStreamFallback,
  At as setSubscriptionPlan,
  wS as setUser,
  _n as setupAuth,
  nf as setupCurrentSession,
  df as setupCurrentSessionResponse,
  _t as setupSession,
  ef as showSurvey,
  _o as socialProfileUrls,
  Xs as sortHosts,
  Qp as startScreenSharing,
  gf as startSession,
  Bm as streamMessageTypes,
  Wm as streamMessages,
  kt as unauthenticated,
  Ae as updateAuthState,
  Pf as updateChimedInUsers,
  Tm as updateCurrentUser,
  mf as updateSession,
  Ff as updateUserMedia,
  Rm as updateUserRoles,
  _f as updateViewCount,
  _S as usdDivisor,
  Jm as useAction,
  xm as useActivateTrial,
  jm as useAuth,
  Hm as useAuthMethods,
  zm as useHasAccess,
  kS as useIntegrations,
  FS as usePrivateQuery,
  MS as usePrivateQueryConfig,
  $S as usePrivateQueryKey,
  LS as useSessionAiFeed,
  xS as useSessionInterruption,
  jS as useSessionPendingAccessStats,
  HS as useUpdateAiFeed,
  Fr as userInitialState,
  sc as usersReducer,
  $o as verifyAuthProvider,
  Mo as verifyOTP
};
